/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as OrgRouteImport } from './routes/_org'
import { Route as ProviderRouteImport } from './routes/_provider'
import { Route as ProviderInviteRouteImport } from './routes/provider-invite'
import { Route as SchedulerDemoRouteImport } from './routes/scheduler-demo'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin/admin/index'
import { Route as OrgOrgOnboardingIndexRouteImport } from './routes/_org/org-onboarding/index'
import { Route as OrgOrgIndexRouteImport } from './routes/_org/org/index'
import { Route as OrgOrgOrgIdRouteImport } from './routes/_org/org/$orgId'
import { Route as ProviderProviderOnboardingIndexRouteImport } from './routes/_provider/provider-onboarding/index'
import { Route as ProviderProviderIndexRouteImport } from './routes/_provider/provider/index'
import { Route as ProviderProviderJobsRouteImport } from './routes/_provider/provider/jobs'
import { Route as AuthOrgNoOrganizationIndexRouteImport } from './routes/auth-org/no-organization/index'
import { Route as AuthOrgSigninIndexRouteImport } from './routes/auth-org/signin/index'
import { Route as AuthProviderSigninIndexRouteImport } from './routes/auth-provider/signin/index'
import { Route as AuthMfaIndexRouteImport } from './routes/auth/mfa/index'
import { Route as JobsIdIndexRouteImport } from './routes/jobs/$id/index'
import { Route as AdminAdminChatIndexRouteImport } from './routes/_admin/admin/chat/index'
import { Route as AdminAdminDashboardIndexRouteImport } from './routes/_admin/admin/dashboard/index'
import { Route as AdminAdminDocumentsIndexRouteImport } from './routes/_admin/admin/documents/index'
import { Route as AdminAdminJobPostsIndexRouteImport } from './routes/_admin/admin/job-posts/index'
import { Route as AdminAdminLeadsIndexRouteImport } from './routes/_admin/admin/leads/index'
import { Route as AdminAdminOrganizationsIndexRouteImport } from './routes/_admin/admin/organizations/index'
import { Route as AdminAdminProviderPayoutsIndexRouteImport } from './routes/_admin/admin/provider-payouts/index'
import { Route as AdminAdminProviderSearchIndexRouteImport } from './routes/_admin/admin/provider-search/index'
import { Route as AdminAdminReferralsIndexRouteImport } from './routes/_admin/admin/referrals/index'
import { Route as AdminAdminUsageBillingIndexRouteImport } from './routes/_admin/admin/usage-billing/index'
import { Route as AdminAdminUsersIndexRouteImport } from './routes/_admin/admin/users/index'
import { Route as OrgOrgOrgIdIndexRouteImport } from './routes/_org/org/$orgId/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId'
import { Route as OrgOrgChatIndexRouteImport } from './routes/_org/org/chat/index'
import { Route as OrgOrgCreateIndexRouteImport } from './routes/_org/org/create/index'
import { Route as OrgOrgFacilitiesIndexRouteImport } from './routes/_org/org/facilities/index'
import { Route as OrgOrgFormsIndexRouteImport } from './routes/_org/org/forms/index'
import { Route as OrgOrgHiringProcessIndexRouteImport } from './routes/_org/org/hiring-process/index'
import { Route as OrgOrgHomeIndexRouteImport } from './routes/_org/org/home/index'
import { Route as OrgOrgJobsIndexRouteImport } from './routes/_org/org/jobs/index'
import { Route as OrgOrgProviderSearchIndexRouteImport } from './routes/_org/org/provider-search/index'
import { Route as OrgOrgProvidersIndexRouteImport } from './routes/_org/org/providers/index'
import { Route as OrgOrgSettingsIndexRouteImport } from './routes/_org/org/settings/index'
import { Route as OrgOrgTeamIndexRouteImport } from './routes/_org/org/team/index'
import { Route as ProviderProviderAffiliationsIndexRouteImport } from './routes/_provider/provider/affiliations/index'
import { Route as ProviderProviderBillingIndexRouteImport } from './routes/_provider/provider/billing/index'
import { Route as ProviderProviderChatIndexRouteImport } from './routes/_provider/provider/chat/index'
import { Route as ProviderProviderCredentialsIndexRouteImport } from './routes/_provider/provider/credentials/index'
import { Route as ProviderProviderDocumentsIndexRouteImport } from './routes/_provider/provider/documents/index'
import { Route as ProviderProviderHomeIndexRouteImport } from './routes/_provider/provider/home/index'
import { Route as ProviderProviderJobsIndexRouteImport } from './routes/_provider/provider/jobs/index'
import { Route as ProviderProviderProcedureLogIndexRouteImport } from './routes/_provider/provider/procedure-log/index'
import { Route as ProviderProviderProfileIndexRouteImport } from './routes/_provider/provider/profile/index'
import { Route as ProviderProviderReferralsIndexRouteImport } from './routes/_provider/provider/referrals/index'
import { Route as ProviderProviderSettingsIndexRouteImport } from './routes/_provider/provider/settings/index'
import { Route as ProviderProviderShiftsIndexRouteImport } from './routes/_provider/provider/shifts/index'
import { Route as ProviderProviderWorkHistoryIndexRouteImport } from './routes/_provider/provider/work-history/index'
import { Route as AuthSigninLinkIndexRouteImport } from './routes/auth/signin/link/index'
import { Route as AuthSigninOauthIndexRouteImport } from './routes/auth/signin/oauth/index'
import { Route as AuthSigninRedirectIndexRouteImport } from './routes/auth/signin/redirect/index'
import { Route as AdminAdminJobPostsJobPostIdIndexRouteImport } from './routes/_admin/admin/job-posts/$jobPostId/index'
import { Route as AdminAdminProviderProfileUserIdIndexRouteImport } from './routes/_admin/admin/provider-profile/$userId/index'
import { Route as AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRouteImport } from './routes/_admin/admin/usage-billing/$organizationBusinessUnitId/index'
import { Route as AdminAdminUsersUserIdIndexRouteImport } from './routes/_admin/admin/users/$userId/index'
import { Route as OrgOrgOrgIdChatIndexRouteImport } from './routes/_org/org/$orgId/chat/index'
import { Route as OrgOrgOrgIdFacilitiesIndexRouteImport } from './routes/_org/org/$orgId/facilities/index'
import { Route as OrgOrgOrgIdHomeIndexRouteImport } from './routes/_org/org/$orgId/home/index'
import { Route as OrgOrgOrgIdJobsIndexRouteImport } from './routes/_org/org/$orgId/jobs/index'
import { Route as OrgOrgOrgIdProviderSearchIndexRouteImport } from './routes/_org/org/$orgId/provider-search/index'
import { Route as OrgOrgOrgIdProvidersIndexRouteImport } from './routes/_org/org/$orgId/providers/index'
import { Route as OrgOrgOrgIdSettingsIndexRouteImport } from './routes/_org/org/$orgId/settings/index'
import { Route as OrgOrgOrgIdTeamIndexRouteImport } from './routes/_org/org/$orgId/team/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/index'
import { Route as OrgOrgJobsOfferIndexRouteImport } from './routes/_org/org/jobs/offer/index'
import { Route as OrgOrgJobsPostIndexRouteImport } from './routes/_org/org/jobs/post/index'
import { Route as OrgOrgJobsTimesheetsIndexRouteImport } from './routes/_org/org/jobs/timesheets/index'
import { Route as OrgOrgProviderProfileUserIdIndexRouteImport } from './routes/_org/org/provider-profile/$userId/index'
import { Route as OrgOrgProvidersAllIndexRouteImport } from './routes/_org/org/providers/all/index'
import { Route as OrgOrgProvidersPoolsIndexRouteImport } from './routes/_org/org/providers/pools/index'
import { Route as OrgOrgProvidersSharedIndexRouteImport } from './routes/_org/org/providers/shared/index'
import { Route as OrgOrgTeamRolesIndexRouteImport } from './routes/_org/org/team/roles/index'
import { Route as ProviderProviderJobsIdIndexRouteImport } from './routes/_provider/provider/jobs/$id/index'
import { Route as ProviderProviderJobsActiveIndexRouteImport } from './routes/_provider/provider/jobs/active/index'
import { Route as ProviderProviderJobsInterestsIndexRouteImport } from './routes/_provider/provider/jobs/interests/index'
import { Route as ProviderProviderJobsOffersIndexRouteImport } from './routes/_provider/provider/jobs/offers/index'
import { Route as ProviderProviderJobsPreferencesIndexRouteImport } from './routes/_provider/provider/jobs/preferences/index'
import { Route as ProviderProviderJobsRecommendedIndexRouteImport } from './routes/_provider/provider/jobs/recommended/index'
import { Route as ProviderProviderJobsSearchIndexRouteImport } from './routes/_provider/provider/jobs/search/index'
import { Route as ProviderProviderJobsTimesheetsIndexRouteImport } from './routes/_provider/provider/jobs/timesheets/index'
import { Route as ProviderProviderShiftsPreferencesIndexRouteImport } from './routes/_provider/provider/shifts/preferences/index'
import { Route as ProviderProviderShiftsSearchIndexRouteImport } from './routes/_provider/provider/shifts/search/index'
import { Route as AdminAdminOrganizationsOrgIdBusinessUnitsIndexRouteImport } from './routes/_admin/admin/organizations/$orgId/business-units/index'
import { Route as OrgOrgOrgIdJobsOfferIndexRouteImport } from './routes/_org/org/$orgId/jobs/offer/index'
import { Route as OrgOrgOrgIdJobsPostIndexRouteImport } from './routes/_org/org/$orgId/jobs/post/index'
import { Route as OrgOrgOrgIdJobsTimesheetsIndexRouteImport } from './routes/_org/org/$orgId/jobs/timesheets/index'
import { Route as OrgOrgOrgIdProvidersAllIndexRouteImport } from './routes/_org/org/$orgId/providers/all/index'
import { Route as OrgOrgOrgIdProvidersPoolsIndexRouteImport } from './routes/_org/org/$orgId/providers/pools/index'
import { Route as OrgOrgOrgIdTeamRolesIndexRouteImport } from './routes/_org/org/$orgId/team/roles/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdBillingIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/billing/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdChatIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/chat/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/facilities/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdFormsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/forms/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/hiring-process/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdHomeIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/home/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/provider-search/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/settings/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdTeamIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/team/index'
import { Route as OrgOrgJobsOfferCreateIndexRouteImport } from './routes/_org/org/jobs/offer/create/index'
import { Route as OrgOrgJobsPostCreateIndexRouteImport } from './routes/_org/org/jobs/post/create/index'
import { Route as OrgOrgProvidersPoolsIdIndexRouteImport } from './routes/_org/org/providers/pools/$id/index'
import { Route as OrgOrgOrgIdJobsOfferCreateIndexRouteImport } from './routes/_org/org/$orgId/jobs/offer/create/index'
import { Route as OrgOrgOrgIdJobsPostCreateIndexRouteImport } from './routes/_org/org/$orgId/jobs/post/create/index'
import { Route as OrgOrgOrgIdProvidersPoolsIdIndexRouteImport } from './routes/_org/org/$orgId/providers/pools/$id/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/offer/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/post/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/timesheets/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/provider-profile/$userId/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/affiliated/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/all/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/credentials/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/invitations/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/pools/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/shared/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/workspace/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/team/roles/index'
import { Route as OrgOrgJobsOfferEditIdIndexRouteImport } from './routes/_org/org/jobs/offer/edit/$id/index'
import { Route as OrgOrgJobsPostDashboardIdIndexRouteImport } from './routes/_org/org/jobs/post/dashboard/$id/index'
import { Route as OrgOrgJobsPostEditIdIndexRouteImport } from './routes/_org/org/jobs/post/edit/$id/index'
import { Route as AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRouteImport } from './routes/_admin/admin/organizations/$orgId/business-units/$businessUnitId/users/index'
import { Route as OrgOrgOrgIdJobsOfferEditIdIndexRouteImport } from './routes/_org/org/$orgId/jobs/offer/edit/$id/index'
import { Route as OrgOrgOrgIdJobsPostDashboardIdIndexRouteImport } from './routes/_org/org/$orgId/jobs/post/dashboard/$id/index'
import { Route as OrgOrgOrgIdJobsPostEditIdIndexRouteImport } from './routes/_org/org/$orgId/jobs/post/edit/$id/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/offer/create/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/post/create/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/providers/pools/$id/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/index'
import { Route as OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRouteImport } from './routes/_org/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/_org',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderRoute = ProviderRouteImport.update({
  id: '/_provider',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderInviteRoute = ProviderInviteRouteImport.update({
  id: '/provider-invite',
  path: '/provider-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulerDemoRoute = SchedulerDemoRouteImport.update({
  id: '/scheduler-demo',
  path: '/scheduler-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AdminRoute,
} as any)
const OrgOrgOnboardingIndexRoute = OrgOrgOnboardingIndexRouteImport.update({
  id: '/org-onboarding/',
  path: '/org-onboarding/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgIndexRoute = OrgOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgOrgIdRoute = OrgOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => OrgRoute,
} as any)
const ProviderProviderOnboardingIndexRoute =
  ProviderProviderOnboardingIndexRouteImport.update({
    id: '/provider-onboarding/',
    path: '/provider-onboarding/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderIndexRoute = ProviderProviderIndexRouteImport.update({
  id: '/provider/',
  path: '/provider/',
  getParentRoute: () => ProviderRoute,
} as any)
const ProviderProviderJobsRoute = ProviderProviderJobsRouteImport.update({
  id: '/provider/jobs',
  path: '/provider/jobs',
  getParentRoute: () => ProviderRoute,
} as any)
const AuthOrgNoOrganizationIndexRoute =
  AuthOrgNoOrganizationIndexRouteImport.update({
    id: '/auth-org/no-organization/',
    path: '/auth-org/no-organization/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthOrgSigninIndexRoute = AuthOrgSigninIndexRouteImport.update({
  id: '/auth-org/signin/',
  path: '/auth-org/signin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthProviderSigninIndexRoute = AuthProviderSigninIndexRouteImport.update({
  id: '/auth-provider/signin/',
  path: '/auth-provider/signin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMfaIndexRoute = AuthMfaIndexRouteImport.update({
  id: '/auth/mfa/',
  path: '/auth/mfa/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIdIndexRoute = JobsIdIndexRouteImport.update({
  id: '/jobs/$id/',
  path: '/jobs/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminChatIndexRoute = AdminAdminChatIndexRouteImport.update({
  id: '/admin/chat/',
  path: '/admin/chat/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminDashboardIndexRoute =
  AdminAdminDashboardIndexRouteImport.update({
    id: '/admin/dashboard/',
    path: '/admin/dashboard/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminDocumentsIndexRoute =
  AdminAdminDocumentsIndexRouteImport.update({
    id: '/admin/documents/',
    path: '/admin/documents/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminJobPostsIndexRoute = AdminAdminJobPostsIndexRouteImport.update({
  id: '/admin/job-posts/',
  path: '/admin/job-posts/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminLeadsIndexRoute = AdminAdminLeadsIndexRouteImport.update({
  id: '/admin/leads/',
  path: '/admin/leads/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminOrganizationsIndexRoute =
  AdminAdminOrganizationsIndexRouteImport.update({
    id: '/admin/organizations/',
    path: '/admin/organizations/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminProviderPayoutsIndexRoute =
  AdminAdminProviderPayoutsIndexRouteImport.update({
    id: '/admin/provider-payouts/',
    path: '/admin/provider-payouts/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminProviderSearchIndexRoute =
  AdminAdminProviderSearchIndexRouteImport.update({
    id: '/admin/provider-search/',
    path: '/admin/provider-search/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminReferralsIndexRoute =
  AdminAdminReferralsIndexRouteImport.update({
    id: '/admin/referrals/',
    path: '/admin/referrals/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminUsageBillingIndexRoute =
  AdminAdminUsageBillingIndexRouteImport.update({
    id: '/admin/usage-billing/',
    path: '/admin/usage-billing/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminUsersIndexRoute = AdminAdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => AdminRoute,
} as any)
const OrgOrgOrgIdIndexRoute = OrgOrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgOrgOrgIdRoute,
} as any)
const OrgOrgBuOrganizationBusinessUnitIdRoute =
  OrgOrgBuOrganizationBusinessUnitIdRouteImport.update({
    id: '/org/bu/$organizationBusinessUnitId',
    path: '/org/bu/$organizationBusinessUnitId',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgChatIndexRoute = OrgOrgChatIndexRouteImport.update({
  id: '/org/chat/',
  path: '/org/chat/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgCreateIndexRoute = OrgOrgCreateIndexRouteImport.update({
  id: '/org/create/',
  path: '/org/create/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgFacilitiesIndexRoute = OrgOrgFacilitiesIndexRouteImport.update({
  id: '/org/facilities/',
  path: '/org/facilities/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgFormsIndexRoute = OrgOrgFormsIndexRouteImport.update({
  id: '/org/forms/',
  path: '/org/forms/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgHiringProcessIndexRoute =
  OrgOrgHiringProcessIndexRouteImport.update({
    id: '/org/hiring-process/',
    path: '/org/hiring-process/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgHomeIndexRoute = OrgOrgHomeIndexRouteImport.update({
  id: '/org/home/',
  path: '/org/home/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgJobsIndexRoute = OrgOrgJobsIndexRouteImport.update({
  id: '/org/jobs/',
  path: '/org/jobs/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgProviderSearchIndexRoute =
  OrgOrgProviderSearchIndexRouteImport.update({
    id: '/org/provider-search/',
    path: '/org/provider-search/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgProvidersIndexRoute = OrgOrgProvidersIndexRouteImport.update({
  id: '/org/providers/',
  path: '/org/providers/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgSettingsIndexRoute = OrgOrgSettingsIndexRouteImport.update({
  id: '/org/settings/',
  path: '/org/settings/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgTeamIndexRoute = OrgOrgTeamIndexRouteImport.update({
  id: '/org/team/',
  path: '/org/team/',
  getParentRoute: () => OrgRoute,
} as any)
const ProviderProviderAffiliationsIndexRoute =
  ProviderProviderAffiliationsIndexRouteImport.update({
    id: '/provider/affiliations/',
    path: '/provider/affiliations/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderBillingIndexRoute =
  ProviderProviderBillingIndexRouteImport.update({
    id: '/provider/billing/',
    path: '/provider/billing/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderChatIndexRoute =
  ProviderProviderChatIndexRouteImport.update({
    id: '/provider/chat/',
    path: '/provider/chat/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderCredentialsIndexRoute =
  ProviderProviderCredentialsIndexRouteImport.update({
    id: '/provider/credentials/',
    path: '/provider/credentials/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderDocumentsIndexRoute =
  ProviderProviderDocumentsIndexRouteImport.update({
    id: '/provider/documents/',
    path: '/provider/documents/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderHomeIndexRoute =
  ProviderProviderHomeIndexRouteImport.update({
    id: '/provider/home/',
    path: '/provider/home/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderJobsIndexRoute =
  ProviderProviderJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderProcedureLogIndexRoute =
  ProviderProviderProcedureLogIndexRouteImport.update({
    id: '/provider/procedure-log/',
    path: '/provider/procedure-log/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderProfileIndexRoute =
  ProviderProviderProfileIndexRouteImport.update({
    id: '/provider/profile/',
    path: '/provider/profile/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderReferralsIndexRoute =
  ProviderProviderReferralsIndexRouteImport.update({
    id: '/provider/referrals/',
    path: '/provider/referrals/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderSettingsIndexRoute =
  ProviderProviderSettingsIndexRouteImport.update({
    id: '/provider/settings/',
    path: '/provider/settings/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderShiftsIndexRoute =
  ProviderProviderShiftsIndexRouteImport.update({
    id: '/provider/shifts/',
    path: '/provider/shifts/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderWorkHistoryIndexRoute =
  ProviderProviderWorkHistoryIndexRouteImport.update({
    id: '/provider/work-history/',
    path: '/provider/work-history/',
    getParentRoute: () => ProviderRoute,
  } as any)
const AuthSigninLinkIndexRoute = AuthSigninLinkIndexRouteImport.update({
  id: '/auth/signin/link/',
  path: '/auth/signin/link/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninOauthIndexRoute = AuthSigninOauthIndexRouteImport.update({
  id: '/auth/signin/oauth/',
  path: '/auth/signin/oauth/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRedirectIndexRoute = AuthSigninRedirectIndexRouteImport.update({
  id: '/auth/signin/redirect/',
  path: '/auth/signin/redirect/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdminJobPostsJobPostIdIndexRoute =
  AdminAdminJobPostsJobPostIdIndexRouteImport.update({
    id: '/admin/job-posts/$jobPostId/',
    path: '/admin/job-posts/$jobPostId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminProviderProfileUserIdIndexRoute =
  AdminAdminProviderProfileUserIdIndexRouteImport.update({
    id: '/admin/provider-profile/$userId/',
    path: '/admin/provider-profile/$userId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute =
  AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRouteImport.update({
    id: '/admin/usage-billing/$organizationBusinessUnitId/',
    path: '/admin/usage-billing/$organizationBusinessUnitId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAdminUsersUserIdIndexRoute =
  AdminAdminUsersUserIdIndexRouteImport.update({
    id: '/admin/users/$userId/',
    path: '/admin/users/$userId/',
    getParentRoute: () => AdminRoute,
  } as any)
const OrgOrgOrgIdChatIndexRoute = OrgOrgOrgIdChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => OrgOrgOrgIdRoute,
} as any)
const OrgOrgOrgIdFacilitiesIndexRoute =
  OrgOrgOrgIdFacilitiesIndexRouteImport.update({
    id: '/facilities/',
    path: '/facilities/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdHomeIndexRoute = OrgOrgOrgIdHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => OrgOrgOrgIdRoute,
} as any)
const OrgOrgOrgIdJobsIndexRoute = OrgOrgOrgIdJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => OrgOrgOrgIdRoute,
} as any)
const OrgOrgOrgIdProviderSearchIndexRoute =
  OrgOrgOrgIdProviderSearchIndexRouteImport.update({
    id: '/provider-search/',
    path: '/provider-search/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdProvidersIndexRoute =
  OrgOrgOrgIdProvidersIndexRouteImport.update({
    id: '/providers/',
    path: '/providers/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdSettingsIndexRoute =
  OrgOrgOrgIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdTeamIndexRoute = OrgOrgOrgIdTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => OrgOrgOrgIdRoute,
} as any)
const OrgOrgBuOrganizationBusinessUnitIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgJobsOfferIndexRoute = OrgOrgJobsOfferIndexRouteImport.update({
  id: '/org/jobs/offer/',
  path: '/org/jobs/offer/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgJobsPostIndexRoute = OrgOrgJobsPostIndexRouteImport.update({
  id: '/org/jobs/post/',
  path: '/org/jobs/post/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgJobsTimesheetsIndexRoute =
  OrgOrgJobsTimesheetsIndexRouteImport.update({
    id: '/org/jobs/timesheets/',
    path: '/org/jobs/timesheets/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgProviderProfileUserIdIndexRoute =
  OrgOrgProviderProfileUserIdIndexRouteImport.update({
    id: '/org/provider-profile/$userId/',
    path: '/org/provider-profile/$userId/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgProvidersAllIndexRoute = OrgOrgProvidersAllIndexRouteImport.update({
  id: '/org/providers/all/',
  path: '/org/providers/all/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgProvidersPoolsIndexRoute =
  OrgOrgProvidersPoolsIndexRouteImport.update({
    id: '/org/providers/pools/',
    path: '/org/providers/pools/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgProvidersSharedIndexRoute =
  OrgOrgProvidersSharedIndexRouteImport.update({
    id: '/org/providers/shared/',
    path: '/org/providers/shared/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgTeamRolesIndexRoute = OrgOrgTeamRolesIndexRouteImport.update({
  id: '/org/team/roles/',
  path: '/org/team/roles/',
  getParentRoute: () => OrgRoute,
} as any)
const ProviderProviderJobsIdIndexRoute =
  ProviderProviderJobsIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderJobsActiveIndexRoute =
  ProviderProviderJobsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderJobsInterestsIndexRoute =
  ProviderProviderJobsInterestsIndexRouteImport.update({
    id: '/interests/',
    path: '/interests/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderJobsOffersIndexRoute =
  ProviderProviderJobsOffersIndexRouteImport.update({
    id: '/offers/',
    path: '/offers/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderJobsPreferencesIndexRoute =
  ProviderProviderJobsPreferencesIndexRouteImport.update({
    id: '/preferences/',
    path: '/preferences/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderJobsRecommendedIndexRoute =
  ProviderProviderJobsRecommendedIndexRouteImport.update({
    id: '/recommended/',
    path: '/recommended/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderJobsSearchIndexRoute =
  ProviderProviderJobsSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderJobsTimesheetsIndexRoute =
  ProviderProviderJobsTimesheetsIndexRouteImport.update({
    id: '/timesheets/',
    path: '/timesheets/',
    getParentRoute: () => ProviderProviderJobsRoute,
  } as any)
const ProviderProviderShiftsPreferencesIndexRoute =
  ProviderProviderShiftsPreferencesIndexRouteImport.update({
    id: '/provider/shifts/preferences/',
    path: '/provider/shifts/preferences/',
    getParentRoute: () => ProviderRoute,
  } as any)
const ProviderProviderShiftsSearchIndexRoute =
  ProviderProviderShiftsSearchIndexRouteImport.update({
    id: '/provider/shifts/search/',
    path: '/provider/shifts/search/',
    getParentRoute: () => ProviderRoute,
  } as any)
const AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute =
  AdminAdminOrganizationsOrgIdBusinessUnitsIndexRouteImport.update({
    id: '/admin/organizations/$orgId/business-units/',
    path: '/admin/organizations/$orgId/business-units/',
    getParentRoute: () => AdminRoute,
  } as any)
const OrgOrgOrgIdJobsOfferIndexRoute =
  OrgOrgOrgIdJobsOfferIndexRouteImport.update({
    id: '/jobs/offer/',
    path: '/jobs/offer/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdJobsPostIndexRoute =
  OrgOrgOrgIdJobsPostIndexRouteImport.update({
    id: '/jobs/post/',
    path: '/jobs/post/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdJobsTimesheetsIndexRoute =
  OrgOrgOrgIdJobsTimesheetsIndexRouteImport.update({
    id: '/jobs/timesheets/',
    path: '/jobs/timesheets/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdProvidersAllIndexRoute =
  OrgOrgOrgIdProvidersAllIndexRouteImport.update({
    id: '/providers/all/',
    path: '/providers/all/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdProvidersPoolsIndexRoute =
  OrgOrgOrgIdProvidersPoolsIndexRouteImport.update({
    id: '/providers/pools/',
    path: '/providers/pools/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdTeamRolesIndexRoute =
  OrgOrgOrgIdTeamRolesIndexRouteImport.update({
    id: '/team/roles/',
    path: '/team/roles/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdChatIndexRouteImport.update({
    id: '/chat/',
    path: '/chat/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRouteImport.update({
    id: '/facilities/',
    path: '/facilities/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdFormsIndexRouteImport.update({
    id: '/forms/',
    path: '/forms/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRouteImport.update({
    id: '/hiring-process/',
    path: '/hiring-process/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdHomeIndexRouteImport.update({
    id: '/home/',
    path: '/home/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRouteImport.update({
    id: '/provider-search/',
    path: '/provider-search/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRouteImport.update({
    id: '/providers/',
    path: '/providers/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdTeamIndexRouteImport.update({
    id: '/team/',
    path: '/team/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgJobsOfferCreateIndexRoute =
  OrgOrgJobsOfferCreateIndexRouteImport.update({
    id: '/org/jobs/offer/create/',
    path: '/org/jobs/offer/create/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgJobsPostCreateIndexRoute =
  OrgOrgJobsPostCreateIndexRouteImport.update({
    id: '/org/jobs/post/create/',
    path: '/org/jobs/post/create/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgProvidersPoolsIdIndexRoute =
  OrgOrgProvidersPoolsIdIndexRouteImport.update({
    id: '/org/providers/pools/$id/',
    path: '/org/providers/pools/$id/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgOrgIdJobsOfferCreateIndexRoute =
  OrgOrgOrgIdJobsOfferCreateIndexRouteImport.update({
    id: '/jobs/offer/create/',
    path: '/jobs/offer/create/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdJobsPostCreateIndexRoute =
  OrgOrgOrgIdJobsPostCreateIndexRouteImport.update({
    id: '/jobs/post/create/',
    path: '/jobs/post/create/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdProvidersPoolsIdIndexRoute =
  OrgOrgOrgIdProvidersPoolsIdIndexRouteImport.update({
    id: '/providers/pools/$id/',
    path: '/providers/pools/$id/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRouteImport.update({
    id: '/jobs/offer/',
    path: '/jobs/offer/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRouteImport.update({
    id: '/jobs/post/',
    path: '/jobs/post/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRouteImport.update({
    id: '/jobs/timesheets/',
    path: '/jobs/timesheets/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRouteImport.update({
    id: '/jobs/wage-sets/',
    path: '/jobs/wage-sets/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRouteImport.update(
    {
      id: '/provider-profile/$userId/',
      path: '/provider-profile/$userId/',
      getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
    } as any,
  )
const OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRouteImport.update({
    id: '/providers/affiliated/',
    path: '/providers/affiliated/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRouteImport.update({
    id: '/providers/all/',
    path: '/providers/all/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRouteImport.update(
    {
      id: '/providers/credentials/',
      path: '/providers/credentials/',
      getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
    } as any,
  )
const OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRouteImport.update(
    {
      id: '/providers/invitations/',
      path: '/providers/invitations/',
      getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
    } as any,
  )
const OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRouteImport.update({
    id: '/providers/pools/',
    path: '/providers/pools/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRouteImport.update({
    id: '/providers/shared/',
    path: '/providers/shared/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRouteImport.update({
    id: '/providers/workspace/',
    path: '/providers/workspace/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRouteImport.update({
    id: '/team/roles/',
    path: '/team/roles/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgJobsOfferEditIdIndexRoute =
  OrgOrgJobsOfferEditIdIndexRouteImport.update({
    id: '/org/jobs/offer/edit/$id/',
    path: '/org/jobs/offer/edit/$id/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgJobsPostDashboardIdIndexRoute =
  OrgOrgJobsPostDashboardIdIndexRouteImport.update({
    id: '/org/jobs/post/dashboard/$id/',
    path: '/org/jobs/post/dashboard/$id/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgOrgJobsPostEditIdIndexRoute =
  OrgOrgJobsPostEditIdIndexRouteImport.update({
    id: '/org/jobs/post/edit/$id/',
    path: '/org/jobs/post/edit/$id/',
    getParentRoute: () => OrgRoute,
  } as any)
const AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute =
  AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRouteImport.update(
    {
      id: '/admin/organizations/$orgId/business-units/$businessUnitId/users/',
      path: '/admin/organizations/$orgId/business-units/$businessUnitId/users/',
      getParentRoute: () => AdminRoute,
    } as any,
  )
const OrgOrgOrgIdJobsOfferEditIdIndexRoute =
  OrgOrgOrgIdJobsOfferEditIdIndexRouteImport.update({
    id: '/jobs/offer/edit/$id/',
    path: '/jobs/offer/edit/$id/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdJobsPostDashboardIdIndexRoute =
  OrgOrgOrgIdJobsPostDashboardIdIndexRouteImport.update({
    id: '/jobs/post/dashboard/$id/',
    path: '/jobs/post/dashboard/$id/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgOrgIdJobsPostEditIdIndexRoute =
  OrgOrgOrgIdJobsPostEditIdIndexRouteImport.update({
    id: '/jobs/post/edit/$id/',
    path: '/jobs/post/edit/$id/',
    getParentRoute: () => OrgOrgOrgIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRouteImport.update({
    id: '/jobs/offer/create/',
    path: '/jobs/offer/create/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRouteImport.update({
    id: '/jobs/post/create/',
    path: '/jobs/post/create/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRouteImport.update(
    {
      id: '/jobs/wage-sets/$organizationWageSetId/',
      path: '/jobs/wage-sets/$organizationWageSetId/',
      getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
    } as any,
  )
const OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRouteImport.update(
    {
      id: '/providers/credentials/$affiliationId/',
      path: '/providers/credentials/$affiliationId/',
      getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
    } as any,
  )
const OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRouteImport.update({
    id: '/providers/pools/$id/',
    path: '/providers/pools/$id/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRouteImport.update({
    id: '/jobs/offer/edit/$id/',
    path: '/jobs/offer/edit/$id/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRouteImport.update({
    id: '/jobs/post/dashboard/$id/',
    path: '/jobs/post/dashboard/$id/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)
const OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute =
  OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRouteImport.update({
    id: '/jobs/post/edit/$id/',
    path: '/jobs/post/edit/$id/',
    getParentRoute: () => OrgOrgBuOrganizationBusinessUnitIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/provider-invite': typeof ProviderInviteRoute
  '/scheduler-demo': typeof SchedulerDemoRoute
  '/org/$orgId': typeof OrgOrgOrgIdRouteWithChildren
  '/provider/jobs': typeof ProviderProviderJobsRouteWithChildren
  '/admin/': typeof AdminAdminIndexRoute
  '/org-onboarding/': typeof OrgOrgOnboardingIndexRoute
  '/org/': typeof OrgOrgIndexRoute
  '/provider-onboarding/': typeof ProviderProviderOnboardingIndexRoute
  '/provider/': typeof ProviderProviderIndexRoute
  '/auth-org/no-organization/': typeof AuthOrgNoOrganizationIndexRoute
  '/auth-org/signin/': typeof AuthOrgSigninIndexRoute
  '/auth-provider/signin/': typeof AuthProviderSigninIndexRoute
  '/auth/mfa/': typeof AuthMfaIndexRoute
  '/jobs/$id/': typeof JobsIdIndexRoute
  '/org/bu/$organizationBusinessUnitId': typeof OrgOrgBuOrganizationBusinessUnitIdRouteWithChildren
  '/admin/chat/': typeof AdminAdminChatIndexRoute
  '/admin/dashboard/': typeof AdminAdminDashboardIndexRoute
  '/admin/documents/': typeof AdminAdminDocumentsIndexRoute
  '/admin/job-posts/': typeof AdminAdminJobPostsIndexRoute
  '/admin/leads/': typeof AdminAdminLeadsIndexRoute
  '/admin/organizations/': typeof AdminAdminOrganizationsIndexRoute
  '/admin/provider-payouts/': typeof AdminAdminProviderPayoutsIndexRoute
  '/admin/provider-search/': typeof AdminAdminProviderSearchIndexRoute
  '/admin/referrals/': typeof AdminAdminReferralsIndexRoute
  '/admin/usage-billing/': typeof AdminAdminUsageBillingIndexRoute
  '/admin/users/': typeof AdminAdminUsersIndexRoute
  '/org/$orgId/': typeof OrgOrgOrgIdIndexRoute
  '/org/chat/': typeof OrgOrgChatIndexRoute
  '/org/create/': typeof OrgOrgCreateIndexRoute
  '/org/facilities/': typeof OrgOrgFacilitiesIndexRoute
  '/org/forms/': typeof OrgOrgFormsIndexRoute
  '/org/hiring-process/': typeof OrgOrgHiringProcessIndexRoute
  '/org/home/': typeof OrgOrgHomeIndexRoute
  '/org/jobs/': typeof OrgOrgJobsIndexRoute
  '/org/provider-search/': typeof OrgOrgProviderSearchIndexRoute
  '/org/providers/': typeof OrgOrgProvidersIndexRoute
  '/org/settings/': typeof OrgOrgSettingsIndexRoute
  '/org/team/': typeof OrgOrgTeamIndexRoute
  '/provider/affiliations/': typeof ProviderProviderAffiliationsIndexRoute
  '/provider/billing/': typeof ProviderProviderBillingIndexRoute
  '/provider/chat/': typeof ProviderProviderChatIndexRoute
  '/provider/credentials/': typeof ProviderProviderCredentialsIndexRoute
  '/provider/documents/': typeof ProviderProviderDocumentsIndexRoute
  '/provider/home/': typeof ProviderProviderHomeIndexRoute
  '/provider/jobs/': typeof ProviderProviderJobsIndexRoute
  '/provider/procedure-log/': typeof ProviderProviderProcedureLogIndexRoute
  '/provider/profile/': typeof ProviderProviderProfileIndexRoute
  '/provider/referrals/': typeof ProviderProviderReferralsIndexRoute
  '/provider/settings/': typeof ProviderProviderSettingsIndexRoute
  '/provider/shifts/': typeof ProviderProviderShiftsIndexRoute
  '/provider/work-history/': typeof ProviderProviderWorkHistoryIndexRoute
  '/auth/signin/link/': typeof AuthSigninLinkIndexRoute
  '/auth/signin/oauth/': typeof AuthSigninOauthIndexRoute
  '/auth/signin/redirect/': typeof AuthSigninRedirectIndexRoute
  '/admin/job-posts/$jobPostId/': typeof AdminAdminJobPostsJobPostIdIndexRoute
  '/admin/provider-profile/$userId/': typeof AdminAdminProviderProfileUserIdIndexRoute
  '/admin/usage-billing/$organizationBusinessUnitId/': typeof AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute
  '/admin/users/$userId/': typeof AdminAdminUsersUserIdIndexRoute
  '/org/$orgId/chat/': typeof OrgOrgOrgIdChatIndexRoute
  '/org/$orgId/facilities/': typeof OrgOrgOrgIdFacilitiesIndexRoute
  '/org/$orgId/home/': typeof OrgOrgOrgIdHomeIndexRoute
  '/org/$orgId/jobs/': typeof OrgOrgOrgIdJobsIndexRoute
  '/org/$orgId/provider-search/': typeof OrgOrgOrgIdProviderSearchIndexRoute
  '/org/$orgId/providers/': typeof OrgOrgOrgIdProvidersIndexRoute
  '/org/$orgId/settings/': typeof OrgOrgOrgIdSettingsIndexRoute
  '/org/$orgId/team/': typeof OrgOrgOrgIdTeamIndexRoute
  '/org/bu/$organizationBusinessUnitId/': typeof OrgOrgBuOrganizationBusinessUnitIdIndexRoute
  '/org/jobs/offer/': typeof OrgOrgJobsOfferIndexRoute
  '/org/jobs/post/': typeof OrgOrgJobsPostIndexRoute
  '/org/jobs/timesheets/': typeof OrgOrgJobsTimesheetsIndexRoute
  '/org/provider-profile/$userId/': typeof OrgOrgProviderProfileUserIdIndexRoute
  '/org/providers/all/': typeof OrgOrgProvidersAllIndexRoute
  '/org/providers/pools/': typeof OrgOrgProvidersPoolsIndexRoute
  '/org/providers/shared/': typeof OrgOrgProvidersSharedIndexRoute
  '/org/team/roles/': typeof OrgOrgTeamRolesIndexRoute
  '/provider/jobs/$id/': typeof ProviderProviderJobsIdIndexRoute
  '/provider/jobs/active/': typeof ProviderProviderJobsActiveIndexRoute
  '/provider/jobs/interests/': typeof ProviderProviderJobsInterestsIndexRoute
  '/provider/jobs/offers/': typeof ProviderProviderJobsOffersIndexRoute
  '/provider/jobs/preferences/': typeof ProviderProviderJobsPreferencesIndexRoute
  '/provider/jobs/recommended/': typeof ProviderProviderJobsRecommendedIndexRoute
  '/provider/jobs/search/': typeof ProviderProviderJobsSearchIndexRoute
  '/provider/jobs/timesheets/': typeof ProviderProviderJobsTimesheetsIndexRoute
  '/provider/shifts/preferences/': typeof ProviderProviderShiftsPreferencesIndexRoute
  '/provider/shifts/search/': typeof ProviderProviderShiftsSearchIndexRoute
  '/admin/organizations/$orgId/business-units/': typeof AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute
  '/org/$orgId/jobs/offer/': typeof OrgOrgOrgIdJobsOfferIndexRoute
  '/org/$orgId/jobs/post/': typeof OrgOrgOrgIdJobsPostIndexRoute
  '/org/$orgId/jobs/timesheets/': typeof OrgOrgOrgIdJobsTimesheetsIndexRoute
  '/org/$orgId/providers/all/': typeof OrgOrgOrgIdProvidersAllIndexRoute
  '/org/$orgId/providers/pools/': typeof OrgOrgOrgIdProvidersPoolsIndexRoute
  '/org/$orgId/team/roles/': typeof OrgOrgOrgIdTeamRolesIndexRoute
  '/org/bu/$organizationBusinessUnitId/billing/': typeof OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute
  '/org/bu/$organizationBusinessUnitId/chat/': typeof OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute
  '/org/bu/$organizationBusinessUnitId/facilities/': typeof OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute
  '/org/bu/$organizationBusinessUnitId/forms/': typeof OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute
  '/org/bu/$organizationBusinessUnitId/hiring-process/': typeof OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute
  '/org/bu/$organizationBusinessUnitId/home/': typeof OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute
  '/org/bu/$organizationBusinessUnitId/provider-search/': typeof OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute
  '/org/bu/$organizationBusinessUnitId/settings/': typeof OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute
  '/org/bu/$organizationBusinessUnitId/team/': typeof OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute
  '/org/jobs/offer/create/': typeof OrgOrgJobsOfferCreateIndexRoute
  '/org/jobs/post/create/': typeof OrgOrgJobsPostCreateIndexRoute
  '/org/providers/pools/$id/': typeof OrgOrgProvidersPoolsIdIndexRoute
  '/org/$orgId/jobs/offer/create/': typeof OrgOrgOrgIdJobsOfferCreateIndexRoute
  '/org/$orgId/jobs/post/create/': typeof OrgOrgOrgIdJobsPostCreateIndexRoute
  '/org/$orgId/providers/pools/$id/': typeof OrgOrgOrgIdProvidersPoolsIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/offer/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/timesheets/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute
  '/org/bu/$organizationBusinessUnitId/provider-profile/$userId/': typeof OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/affiliated/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/all/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/credentials/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/invitations/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/pools/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/shared/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/workspace/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute
  '/org/bu/$organizationBusinessUnitId/team/roles/': typeof OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute
  '/org/jobs/offer/edit/$id/': typeof OrgOrgJobsOfferEditIdIndexRoute
  '/org/jobs/post/dashboard/$id/': typeof OrgOrgJobsPostDashboardIdIndexRoute
  '/org/jobs/post/edit/$id/': typeof OrgOrgJobsPostEditIdIndexRoute
  '/admin/organizations/$orgId/business-units/$businessUnitId/users/': typeof AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute
  '/org/$orgId/jobs/offer/edit/$id/': typeof OrgOrgOrgIdJobsOfferEditIdIndexRoute
  '/org/$orgId/jobs/post/dashboard/$id/': typeof OrgOrgOrgIdJobsPostDashboardIdIndexRoute
  '/org/$orgId/jobs/post/edit/$id/': typeof OrgOrgOrgIdJobsPostEditIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/offer/create/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post/create/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/pools/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/provider-invite': typeof ProviderInviteRoute
  '/scheduler-demo': typeof SchedulerDemoRoute
  '/admin': typeof AdminAdminIndexRoute
  '/org-onboarding': typeof OrgOrgOnboardingIndexRoute
  '/org': typeof OrgOrgIndexRoute
  '/provider-onboarding': typeof ProviderProviderOnboardingIndexRoute
  '/provider': typeof ProviderProviderIndexRoute
  '/auth-org/no-organization': typeof AuthOrgNoOrganizationIndexRoute
  '/auth-org/signin': typeof AuthOrgSigninIndexRoute
  '/auth-provider/signin': typeof AuthProviderSigninIndexRoute
  '/auth/mfa': typeof AuthMfaIndexRoute
  '/jobs/$id': typeof JobsIdIndexRoute
  '/admin/chat': typeof AdminAdminChatIndexRoute
  '/admin/dashboard': typeof AdminAdminDashboardIndexRoute
  '/admin/documents': typeof AdminAdminDocumentsIndexRoute
  '/admin/job-posts': typeof AdminAdminJobPostsIndexRoute
  '/admin/leads': typeof AdminAdminLeadsIndexRoute
  '/admin/organizations': typeof AdminAdminOrganizationsIndexRoute
  '/admin/provider-payouts': typeof AdminAdminProviderPayoutsIndexRoute
  '/admin/provider-search': typeof AdminAdminProviderSearchIndexRoute
  '/admin/referrals': typeof AdminAdminReferralsIndexRoute
  '/admin/usage-billing': typeof AdminAdminUsageBillingIndexRoute
  '/admin/users': typeof AdminAdminUsersIndexRoute
  '/org/$orgId': typeof OrgOrgOrgIdIndexRoute
  '/org/chat': typeof OrgOrgChatIndexRoute
  '/org/create': typeof OrgOrgCreateIndexRoute
  '/org/facilities': typeof OrgOrgFacilitiesIndexRoute
  '/org/forms': typeof OrgOrgFormsIndexRoute
  '/org/hiring-process': typeof OrgOrgHiringProcessIndexRoute
  '/org/home': typeof OrgOrgHomeIndexRoute
  '/org/jobs': typeof OrgOrgJobsIndexRoute
  '/org/provider-search': typeof OrgOrgProviderSearchIndexRoute
  '/org/providers': typeof OrgOrgProvidersIndexRoute
  '/org/settings': typeof OrgOrgSettingsIndexRoute
  '/org/team': typeof OrgOrgTeamIndexRoute
  '/provider/affiliations': typeof ProviderProviderAffiliationsIndexRoute
  '/provider/billing': typeof ProviderProviderBillingIndexRoute
  '/provider/chat': typeof ProviderProviderChatIndexRoute
  '/provider/credentials': typeof ProviderProviderCredentialsIndexRoute
  '/provider/documents': typeof ProviderProviderDocumentsIndexRoute
  '/provider/home': typeof ProviderProviderHomeIndexRoute
  '/provider/jobs': typeof ProviderProviderJobsIndexRoute
  '/provider/procedure-log': typeof ProviderProviderProcedureLogIndexRoute
  '/provider/profile': typeof ProviderProviderProfileIndexRoute
  '/provider/referrals': typeof ProviderProviderReferralsIndexRoute
  '/provider/settings': typeof ProviderProviderSettingsIndexRoute
  '/provider/shifts': typeof ProviderProviderShiftsIndexRoute
  '/provider/work-history': typeof ProviderProviderWorkHistoryIndexRoute
  '/auth/signin/link': typeof AuthSigninLinkIndexRoute
  '/auth/signin/oauth': typeof AuthSigninOauthIndexRoute
  '/auth/signin/redirect': typeof AuthSigninRedirectIndexRoute
  '/admin/job-posts/$jobPostId': typeof AdminAdminJobPostsJobPostIdIndexRoute
  '/admin/provider-profile/$userId': typeof AdminAdminProviderProfileUserIdIndexRoute
  '/admin/usage-billing/$organizationBusinessUnitId': typeof AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute
  '/admin/users/$userId': typeof AdminAdminUsersUserIdIndexRoute
  '/org/$orgId/chat': typeof OrgOrgOrgIdChatIndexRoute
  '/org/$orgId/facilities': typeof OrgOrgOrgIdFacilitiesIndexRoute
  '/org/$orgId/home': typeof OrgOrgOrgIdHomeIndexRoute
  '/org/$orgId/jobs': typeof OrgOrgOrgIdJobsIndexRoute
  '/org/$orgId/provider-search': typeof OrgOrgOrgIdProviderSearchIndexRoute
  '/org/$orgId/providers': typeof OrgOrgOrgIdProvidersIndexRoute
  '/org/$orgId/settings': typeof OrgOrgOrgIdSettingsIndexRoute
  '/org/$orgId/team': typeof OrgOrgOrgIdTeamIndexRoute
  '/org/bu/$organizationBusinessUnitId': typeof OrgOrgBuOrganizationBusinessUnitIdIndexRoute
  '/org/jobs/offer': typeof OrgOrgJobsOfferIndexRoute
  '/org/jobs/post': typeof OrgOrgJobsPostIndexRoute
  '/org/jobs/timesheets': typeof OrgOrgJobsTimesheetsIndexRoute
  '/org/provider-profile/$userId': typeof OrgOrgProviderProfileUserIdIndexRoute
  '/org/providers/all': typeof OrgOrgProvidersAllIndexRoute
  '/org/providers/pools': typeof OrgOrgProvidersPoolsIndexRoute
  '/org/providers/shared': typeof OrgOrgProvidersSharedIndexRoute
  '/org/team/roles': typeof OrgOrgTeamRolesIndexRoute
  '/provider/jobs/$id': typeof ProviderProviderJobsIdIndexRoute
  '/provider/jobs/active': typeof ProviderProviderJobsActiveIndexRoute
  '/provider/jobs/interests': typeof ProviderProviderJobsInterestsIndexRoute
  '/provider/jobs/offers': typeof ProviderProviderJobsOffersIndexRoute
  '/provider/jobs/preferences': typeof ProviderProviderJobsPreferencesIndexRoute
  '/provider/jobs/recommended': typeof ProviderProviderJobsRecommendedIndexRoute
  '/provider/jobs/search': typeof ProviderProviderJobsSearchIndexRoute
  '/provider/jobs/timesheets': typeof ProviderProviderJobsTimesheetsIndexRoute
  '/provider/shifts/preferences': typeof ProviderProviderShiftsPreferencesIndexRoute
  '/provider/shifts/search': typeof ProviderProviderShiftsSearchIndexRoute
  '/admin/organizations/$orgId/business-units': typeof AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute
  '/org/$orgId/jobs/offer': typeof OrgOrgOrgIdJobsOfferIndexRoute
  '/org/$orgId/jobs/post': typeof OrgOrgOrgIdJobsPostIndexRoute
  '/org/$orgId/jobs/timesheets': typeof OrgOrgOrgIdJobsTimesheetsIndexRoute
  '/org/$orgId/providers/all': typeof OrgOrgOrgIdProvidersAllIndexRoute
  '/org/$orgId/providers/pools': typeof OrgOrgOrgIdProvidersPoolsIndexRoute
  '/org/$orgId/team/roles': typeof OrgOrgOrgIdTeamRolesIndexRoute
  '/org/bu/$organizationBusinessUnitId/billing': typeof OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute
  '/org/bu/$organizationBusinessUnitId/chat': typeof OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute
  '/org/bu/$organizationBusinessUnitId/facilities': typeof OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute
  '/org/bu/$organizationBusinessUnitId/forms': typeof OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute
  '/org/bu/$organizationBusinessUnitId/hiring-process': typeof OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute
  '/org/bu/$organizationBusinessUnitId/home': typeof OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs': typeof OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute
  '/org/bu/$organizationBusinessUnitId/provider-search': typeof OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute
  '/org/bu/$organizationBusinessUnitId/settings': typeof OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute
  '/org/bu/$organizationBusinessUnitId/team': typeof OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute
  '/org/jobs/offer/create': typeof OrgOrgJobsOfferCreateIndexRoute
  '/org/jobs/post/create': typeof OrgOrgJobsPostCreateIndexRoute
  '/org/providers/pools/$id': typeof OrgOrgProvidersPoolsIdIndexRoute
  '/org/$orgId/jobs/offer/create': typeof OrgOrgOrgIdJobsOfferCreateIndexRoute
  '/org/$orgId/jobs/post/create': typeof OrgOrgOrgIdJobsPostCreateIndexRoute
  '/org/$orgId/providers/pools/$id': typeof OrgOrgOrgIdProvidersPoolsIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/offer': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/timesheets': typeof OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/wage-sets': typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute
  '/org/bu/$organizationBusinessUnitId/provider-profile/$userId': typeof OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/affiliated': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/all': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/credentials': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/invitations': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/pools': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/shared': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/workspace': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute
  '/org/bu/$organizationBusinessUnitId/team/roles': typeof OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute
  '/org/jobs/offer/edit/$id': typeof OrgOrgJobsOfferEditIdIndexRoute
  '/org/jobs/post/dashboard/$id': typeof OrgOrgJobsPostDashboardIdIndexRoute
  '/org/jobs/post/edit/$id': typeof OrgOrgJobsPostEditIdIndexRoute
  '/admin/organizations/$orgId/business-units/$businessUnitId/users': typeof AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute
  '/org/$orgId/jobs/offer/edit/$id': typeof OrgOrgOrgIdJobsOfferEditIdIndexRoute
  '/org/$orgId/jobs/post/dashboard/$id': typeof OrgOrgOrgIdJobsPostDashboardIdIndexRoute
  '/org/$orgId/jobs/post/edit/$id': typeof OrgOrgOrgIdJobsPostEditIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/offer/create': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post/create': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId': typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/providers/pools/$id': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute
  '/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/_org': typeof OrgRouteWithChildren
  '/_provider': typeof ProviderRouteWithChildren
  '/provider-invite': typeof ProviderInviteRoute
  '/scheduler-demo': typeof SchedulerDemoRoute
  '/_org/org/$orgId': typeof OrgOrgOrgIdRouteWithChildren
  '/_provider/provider/jobs': typeof ProviderProviderJobsRouteWithChildren
  '/_admin/admin/': typeof AdminAdminIndexRoute
  '/_org/org-onboarding/': typeof OrgOrgOnboardingIndexRoute
  '/_org/org/': typeof OrgOrgIndexRoute
  '/_provider/provider-onboarding/': typeof ProviderProviderOnboardingIndexRoute
  '/_provider/provider/': typeof ProviderProviderIndexRoute
  '/auth-org/no-organization/': typeof AuthOrgNoOrganizationIndexRoute
  '/auth-org/signin/': typeof AuthOrgSigninIndexRoute
  '/auth-provider/signin/': typeof AuthProviderSigninIndexRoute
  '/auth/mfa/': typeof AuthMfaIndexRoute
  '/jobs/$id/': typeof JobsIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId': typeof OrgOrgBuOrganizationBusinessUnitIdRouteWithChildren
  '/_admin/admin/chat/': typeof AdminAdminChatIndexRoute
  '/_admin/admin/dashboard/': typeof AdminAdminDashboardIndexRoute
  '/_admin/admin/documents/': typeof AdminAdminDocumentsIndexRoute
  '/_admin/admin/job-posts/': typeof AdminAdminJobPostsIndexRoute
  '/_admin/admin/leads/': typeof AdminAdminLeadsIndexRoute
  '/_admin/admin/organizations/': typeof AdminAdminOrganizationsIndexRoute
  '/_admin/admin/provider-payouts/': typeof AdminAdminProviderPayoutsIndexRoute
  '/_admin/admin/provider-search/': typeof AdminAdminProviderSearchIndexRoute
  '/_admin/admin/referrals/': typeof AdminAdminReferralsIndexRoute
  '/_admin/admin/usage-billing/': typeof AdminAdminUsageBillingIndexRoute
  '/_admin/admin/users/': typeof AdminAdminUsersIndexRoute
  '/_org/org/$orgId/': typeof OrgOrgOrgIdIndexRoute
  '/_org/org/chat/': typeof OrgOrgChatIndexRoute
  '/_org/org/create/': typeof OrgOrgCreateIndexRoute
  '/_org/org/facilities/': typeof OrgOrgFacilitiesIndexRoute
  '/_org/org/forms/': typeof OrgOrgFormsIndexRoute
  '/_org/org/hiring-process/': typeof OrgOrgHiringProcessIndexRoute
  '/_org/org/home/': typeof OrgOrgHomeIndexRoute
  '/_org/org/jobs/': typeof OrgOrgJobsIndexRoute
  '/_org/org/provider-search/': typeof OrgOrgProviderSearchIndexRoute
  '/_org/org/providers/': typeof OrgOrgProvidersIndexRoute
  '/_org/org/settings/': typeof OrgOrgSettingsIndexRoute
  '/_org/org/team/': typeof OrgOrgTeamIndexRoute
  '/_provider/provider/affiliations/': typeof ProviderProviderAffiliationsIndexRoute
  '/_provider/provider/billing/': typeof ProviderProviderBillingIndexRoute
  '/_provider/provider/chat/': typeof ProviderProviderChatIndexRoute
  '/_provider/provider/credentials/': typeof ProviderProviderCredentialsIndexRoute
  '/_provider/provider/documents/': typeof ProviderProviderDocumentsIndexRoute
  '/_provider/provider/home/': typeof ProviderProviderHomeIndexRoute
  '/_provider/provider/jobs/': typeof ProviderProviderJobsIndexRoute
  '/_provider/provider/procedure-log/': typeof ProviderProviderProcedureLogIndexRoute
  '/_provider/provider/profile/': typeof ProviderProviderProfileIndexRoute
  '/_provider/provider/referrals/': typeof ProviderProviderReferralsIndexRoute
  '/_provider/provider/settings/': typeof ProviderProviderSettingsIndexRoute
  '/_provider/provider/shifts/': typeof ProviderProviderShiftsIndexRoute
  '/_provider/provider/work-history/': typeof ProviderProviderWorkHistoryIndexRoute
  '/auth/signin/link/': typeof AuthSigninLinkIndexRoute
  '/auth/signin/oauth/': typeof AuthSigninOauthIndexRoute
  '/auth/signin/redirect/': typeof AuthSigninRedirectIndexRoute
  '/_admin/admin/job-posts/$jobPostId/': typeof AdminAdminJobPostsJobPostIdIndexRoute
  '/_admin/admin/provider-profile/$userId/': typeof AdminAdminProviderProfileUserIdIndexRoute
  '/_admin/admin/usage-billing/$organizationBusinessUnitId/': typeof AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute
  '/_admin/admin/users/$userId/': typeof AdminAdminUsersUserIdIndexRoute
  '/_org/org/$orgId/chat/': typeof OrgOrgOrgIdChatIndexRoute
  '/_org/org/$orgId/facilities/': typeof OrgOrgOrgIdFacilitiesIndexRoute
  '/_org/org/$orgId/home/': typeof OrgOrgOrgIdHomeIndexRoute
  '/_org/org/$orgId/jobs/': typeof OrgOrgOrgIdJobsIndexRoute
  '/_org/org/$orgId/provider-search/': typeof OrgOrgOrgIdProviderSearchIndexRoute
  '/_org/org/$orgId/providers/': typeof OrgOrgOrgIdProvidersIndexRoute
  '/_org/org/$orgId/settings/': typeof OrgOrgOrgIdSettingsIndexRoute
  '/_org/org/$orgId/team/': typeof OrgOrgOrgIdTeamIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/': typeof OrgOrgBuOrganizationBusinessUnitIdIndexRoute
  '/_org/org/jobs/offer/': typeof OrgOrgJobsOfferIndexRoute
  '/_org/org/jobs/post/': typeof OrgOrgJobsPostIndexRoute
  '/_org/org/jobs/timesheets/': typeof OrgOrgJobsTimesheetsIndexRoute
  '/_org/org/provider-profile/$userId/': typeof OrgOrgProviderProfileUserIdIndexRoute
  '/_org/org/providers/all/': typeof OrgOrgProvidersAllIndexRoute
  '/_org/org/providers/pools/': typeof OrgOrgProvidersPoolsIndexRoute
  '/_org/org/providers/shared/': typeof OrgOrgProvidersSharedIndexRoute
  '/_org/org/team/roles/': typeof OrgOrgTeamRolesIndexRoute
  '/_provider/provider/jobs/$id/': typeof ProviderProviderJobsIdIndexRoute
  '/_provider/provider/jobs/active/': typeof ProviderProviderJobsActiveIndexRoute
  '/_provider/provider/jobs/interests/': typeof ProviderProviderJobsInterestsIndexRoute
  '/_provider/provider/jobs/offers/': typeof ProviderProviderJobsOffersIndexRoute
  '/_provider/provider/jobs/preferences/': typeof ProviderProviderJobsPreferencesIndexRoute
  '/_provider/provider/jobs/recommended/': typeof ProviderProviderJobsRecommendedIndexRoute
  '/_provider/provider/jobs/search/': typeof ProviderProviderJobsSearchIndexRoute
  '/_provider/provider/jobs/timesheets/': typeof ProviderProviderJobsTimesheetsIndexRoute
  '/_provider/provider/shifts/preferences/': typeof ProviderProviderShiftsPreferencesIndexRoute
  '/_provider/provider/shifts/search/': typeof ProviderProviderShiftsSearchIndexRoute
  '/_admin/admin/organizations/$orgId/business-units/': typeof AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute
  '/_org/org/$orgId/jobs/offer/': typeof OrgOrgOrgIdJobsOfferIndexRoute
  '/_org/org/$orgId/jobs/post/': typeof OrgOrgOrgIdJobsPostIndexRoute
  '/_org/org/$orgId/jobs/timesheets/': typeof OrgOrgOrgIdJobsTimesheetsIndexRoute
  '/_org/org/$orgId/providers/all/': typeof OrgOrgOrgIdProvidersAllIndexRoute
  '/_org/org/$orgId/providers/pools/': typeof OrgOrgOrgIdProvidersPoolsIndexRoute
  '/_org/org/$orgId/team/roles/': typeof OrgOrgOrgIdTeamRolesIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/billing/': typeof OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/chat/': typeof OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/facilities/': typeof OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/forms/': typeof OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/hiring-process/': typeof OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/home/': typeof OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/provider-search/': typeof OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/settings/': typeof OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/team/': typeof OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute
  '/_org/org/jobs/offer/create/': typeof OrgOrgJobsOfferCreateIndexRoute
  '/_org/org/jobs/post/create/': typeof OrgOrgJobsPostCreateIndexRoute
  '/_org/org/providers/pools/$id/': typeof OrgOrgProvidersPoolsIdIndexRoute
  '/_org/org/$orgId/jobs/offer/create/': typeof OrgOrgOrgIdJobsOfferCreateIndexRoute
  '/_org/org/$orgId/jobs/post/create/': typeof OrgOrgOrgIdJobsPostCreateIndexRoute
  '/_org/org/$orgId/providers/pools/$id/': typeof OrgOrgOrgIdProvidersPoolsIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/post/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/timesheets/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/provider-profile/$userId/': typeof OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/affiliated/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/all/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/invitations/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/pools/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/shared/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/workspace/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/team/roles/': typeof OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute
  '/_org/org/jobs/offer/edit/$id/': typeof OrgOrgJobsOfferEditIdIndexRoute
  '/_org/org/jobs/post/dashboard/$id/': typeof OrgOrgJobsPostDashboardIdIndexRoute
  '/_org/org/jobs/post/edit/$id/': typeof OrgOrgJobsPostEditIdIndexRoute
  '/_admin/admin/organizations/$orgId/business-units/$businessUnitId/users/': typeof AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute
  '/_org/org/$orgId/jobs/offer/edit/$id/': typeof OrgOrgOrgIdJobsOfferEditIdIndexRoute
  '/_org/org/$orgId/jobs/post/dashboard/$id/': typeof OrgOrgOrgIdJobsPostDashboardIdIndexRoute
  '/_org/org/$orgId/jobs/post/edit/$id/': typeof OrgOrgOrgIdJobsPostEditIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/create/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/post/create/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/providers/pools/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute
  '/_org/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/': typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/provider-invite'
    | '/scheduler-demo'
    | '/org/$orgId'
    | '/provider/jobs'
    | '/admin/'
    | '/org-onboarding/'
    | '/org/'
    | '/provider-onboarding/'
    | '/provider/'
    | '/auth-org/no-organization/'
    | '/auth-org/signin/'
    | '/auth-provider/signin/'
    | '/auth/mfa/'
    | '/jobs/$id/'
    | '/org/bu/$organizationBusinessUnitId'
    | '/admin/chat/'
    | '/admin/dashboard/'
    | '/admin/documents/'
    | '/admin/job-posts/'
    | '/admin/leads/'
    | '/admin/organizations/'
    | '/admin/provider-payouts/'
    | '/admin/provider-search/'
    | '/admin/referrals/'
    | '/admin/usage-billing/'
    | '/admin/users/'
    | '/org/$orgId/'
    | '/org/chat/'
    | '/org/create/'
    | '/org/facilities/'
    | '/org/forms/'
    | '/org/hiring-process/'
    | '/org/home/'
    | '/org/jobs/'
    | '/org/provider-search/'
    | '/org/providers/'
    | '/org/settings/'
    | '/org/team/'
    | '/provider/affiliations/'
    | '/provider/billing/'
    | '/provider/chat/'
    | '/provider/credentials/'
    | '/provider/documents/'
    | '/provider/home/'
    | '/provider/jobs/'
    | '/provider/procedure-log/'
    | '/provider/profile/'
    | '/provider/referrals/'
    | '/provider/settings/'
    | '/provider/shifts/'
    | '/provider/work-history/'
    | '/auth/signin/link/'
    | '/auth/signin/oauth/'
    | '/auth/signin/redirect/'
    | '/admin/job-posts/$jobPostId/'
    | '/admin/provider-profile/$userId/'
    | '/admin/usage-billing/$organizationBusinessUnitId/'
    | '/admin/users/$userId/'
    | '/org/$orgId/chat/'
    | '/org/$orgId/facilities/'
    | '/org/$orgId/home/'
    | '/org/$orgId/jobs/'
    | '/org/$orgId/provider-search/'
    | '/org/$orgId/providers/'
    | '/org/$orgId/settings/'
    | '/org/$orgId/team/'
    | '/org/bu/$organizationBusinessUnitId/'
    | '/org/jobs/offer/'
    | '/org/jobs/post/'
    | '/org/jobs/timesheets/'
    | '/org/provider-profile/$userId/'
    | '/org/providers/all/'
    | '/org/providers/pools/'
    | '/org/providers/shared/'
    | '/org/team/roles/'
    | '/provider/jobs/$id/'
    | '/provider/jobs/active/'
    | '/provider/jobs/interests/'
    | '/provider/jobs/offers/'
    | '/provider/jobs/preferences/'
    | '/provider/jobs/recommended/'
    | '/provider/jobs/search/'
    | '/provider/jobs/timesheets/'
    | '/provider/shifts/preferences/'
    | '/provider/shifts/search/'
    | '/admin/organizations/$orgId/business-units/'
    | '/org/$orgId/jobs/offer/'
    | '/org/$orgId/jobs/post/'
    | '/org/$orgId/jobs/timesheets/'
    | '/org/$orgId/providers/all/'
    | '/org/$orgId/providers/pools/'
    | '/org/$orgId/team/roles/'
    | '/org/bu/$organizationBusinessUnitId/billing/'
    | '/org/bu/$organizationBusinessUnitId/chat/'
    | '/org/bu/$organizationBusinessUnitId/facilities/'
    | '/org/bu/$organizationBusinessUnitId/forms/'
    | '/org/bu/$organizationBusinessUnitId/hiring-process/'
    | '/org/bu/$organizationBusinessUnitId/home/'
    | '/org/bu/$organizationBusinessUnitId/jobs/'
    | '/org/bu/$organizationBusinessUnitId/provider-search/'
    | '/org/bu/$organizationBusinessUnitId/providers/'
    | '/org/bu/$organizationBusinessUnitId/settings/'
    | '/org/bu/$organizationBusinessUnitId/team/'
    | '/org/jobs/offer/create/'
    | '/org/jobs/post/create/'
    | '/org/providers/pools/$id/'
    | '/org/$orgId/jobs/offer/create/'
    | '/org/$orgId/jobs/post/create/'
    | '/org/$orgId/providers/pools/$id/'
    | '/org/bu/$organizationBusinessUnitId/jobs/offer/'
    | '/org/bu/$organizationBusinessUnitId/jobs/post/'
    | '/org/bu/$organizationBusinessUnitId/jobs/timesheets/'
    | '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/'
    | '/org/bu/$organizationBusinessUnitId/provider-profile/$userId/'
    | '/org/bu/$organizationBusinessUnitId/providers/affiliated/'
    | '/org/bu/$organizationBusinessUnitId/providers/all/'
    | '/org/bu/$organizationBusinessUnitId/providers/credentials/'
    | '/org/bu/$organizationBusinessUnitId/providers/invitations/'
    | '/org/bu/$organizationBusinessUnitId/providers/pools/'
    | '/org/bu/$organizationBusinessUnitId/providers/shared/'
    | '/org/bu/$organizationBusinessUnitId/providers/workspace/'
    | '/org/bu/$organizationBusinessUnitId/team/roles/'
    | '/org/jobs/offer/edit/$id/'
    | '/org/jobs/post/dashboard/$id/'
    | '/org/jobs/post/edit/$id/'
    | '/admin/organizations/$orgId/business-units/$businessUnitId/users/'
    | '/org/$orgId/jobs/offer/edit/$id/'
    | '/org/$orgId/jobs/post/dashboard/$id/'
    | '/org/$orgId/jobs/post/edit/$id/'
    | '/org/bu/$organizationBusinessUnitId/jobs/offer/create/'
    | '/org/bu/$organizationBusinessUnitId/jobs/post/create/'
    | '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/'
    | '/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/'
    | '/org/bu/$organizationBusinessUnitId/providers/pools/$id/'
    | '/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/'
    | '/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/'
    | '/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/provider-invite'
    | '/scheduler-demo'
    | '/admin'
    | '/org-onboarding'
    | '/org'
    | '/provider-onboarding'
    | '/provider'
    | '/auth-org/no-organization'
    | '/auth-org/signin'
    | '/auth-provider/signin'
    | '/auth/mfa'
    | '/jobs/$id'
    | '/admin/chat'
    | '/admin/dashboard'
    | '/admin/documents'
    | '/admin/job-posts'
    | '/admin/leads'
    | '/admin/organizations'
    | '/admin/provider-payouts'
    | '/admin/provider-search'
    | '/admin/referrals'
    | '/admin/usage-billing'
    | '/admin/users'
    | '/org/$orgId'
    | '/org/chat'
    | '/org/create'
    | '/org/facilities'
    | '/org/forms'
    | '/org/hiring-process'
    | '/org/home'
    | '/org/jobs'
    | '/org/provider-search'
    | '/org/providers'
    | '/org/settings'
    | '/org/team'
    | '/provider/affiliations'
    | '/provider/billing'
    | '/provider/chat'
    | '/provider/credentials'
    | '/provider/documents'
    | '/provider/home'
    | '/provider/jobs'
    | '/provider/procedure-log'
    | '/provider/profile'
    | '/provider/referrals'
    | '/provider/settings'
    | '/provider/shifts'
    | '/provider/work-history'
    | '/auth/signin/link'
    | '/auth/signin/oauth'
    | '/auth/signin/redirect'
    | '/admin/job-posts/$jobPostId'
    | '/admin/provider-profile/$userId'
    | '/admin/usage-billing/$organizationBusinessUnitId'
    | '/admin/users/$userId'
    | '/org/$orgId/chat'
    | '/org/$orgId/facilities'
    | '/org/$orgId/home'
    | '/org/$orgId/jobs'
    | '/org/$orgId/provider-search'
    | '/org/$orgId/providers'
    | '/org/$orgId/settings'
    | '/org/$orgId/team'
    | '/org/bu/$organizationBusinessUnitId'
    | '/org/jobs/offer'
    | '/org/jobs/post'
    | '/org/jobs/timesheets'
    | '/org/provider-profile/$userId'
    | '/org/providers/all'
    | '/org/providers/pools'
    | '/org/providers/shared'
    | '/org/team/roles'
    | '/provider/jobs/$id'
    | '/provider/jobs/active'
    | '/provider/jobs/interests'
    | '/provider/jobs/offers'
    | '/provider/jobs/preferences'
    | '/provider/jobs/recommended'
    | '/provider/jobs/search'
    | '/provider/jobs/timesheets'
    | '/provider/shifts/preferences'
    | '/provider/shifts/search'
    | '/admin/organizations/$orgId/business-units'
    | '/org/$orgId/jobs/offer'
    | '/org/$orgId/jobs/post'
    | '/org/$orgId/jobs/timesheets'
    | '/org/$orgId/providers/all'
    | '/org/$orgId/providers/pools'
    | '/org/$orgId/team/roles'
    | '/org/bu/$organizationBusinessUnitId/billing'
    | '/org/bu/$organizationBusinessUnitId/chat'
    | '/org/bu/$organizationBusinessUnitId/facilities'
    | '/org/bu/$organizationBusinessUnitId/forms'
    | '/org/bu/$organizationBusinessUnitId/hiring-process'
    | '/org/bu/$organizationBusinessUnitId/home'
    | '/org/bu/$organizationBusinessUnitId/jobs'
    | '/org/bu/$organizationBusinessUnitId/provider-search'
    | '/org/bu/$organizationBusinessUnitId/providers'
    | '/org/bu/$organizationBusinessUnitId/settings'
    | '/org/bu/$organizationBusinessUnitId/team'
    | '/org/jobs/offer/create'
    | '/org/jobs/post/create'
    | '/org/providers/pools/$id'
    | '/org/$orgId/jobs/offer/create'
    | '/org/$orgId/jobs/post/create'
    | '/org/$orgId/providers/pools/$id'
    | '/org/bu/$organizationBusinessUnitId/jobs/offer'
    | '/org/bu/$organizationBusinessUnitId/jobs/post'
    | '/org/bu/$organizationBusinessUnitId/jobs/timesheets'
    | '/org/bu/$organizationBusinessUnitId/jobs/wage-sets'
    | '/org/bu/$organizationBusinessUnitId/provider-profile/$userId'
    | '/org/bu/$organizationBusinessUnitId/providers/affiliated'
    | '/org/bu/$organizationBusinessUnitId/providers/all'
    | '/org/bu/$organizationBusinessUnitId/providers/credentials'
    | '/org/bu/$organizationBusinessUnitId/providers/invitations'
    | '/org/bu/$organizationBusinessUnitId/providers/pools'
    | '/org/bu/$organizationBusinessUnitId/providers/shared'
    | '/org/bu/$organizationBusinessUnitId/providers/workspace'
    | '/org/bu/$organizationBusinessUnitId/team/roles'
    | '/org/jobs/offer/edit/$id'
    | '/org/jobs/post/dashboard/$id'
    | '/org/jobs/post/edit/$id'
    | '/admin/organizations/$orgId/business-units/$businessUnitId/users'
    | '/org/$orgId/jobs/offer/edit/$id'
    | '/org/$orgId/jobs/post/dashboard/$id'
    | '/org/$orgId/jobs/post/edit/$id'
    | '/org/bu/$organizationBusinessUnitId/jobs/offer/create'
    | '/org/bu/$organizationBusinessUnitId/jobs/post/create'
    | '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId'
    | '/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId'
    | '/org/bu/$organizationBusinessUnitId/providers/pools/$id'
    | '/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id'
    | '/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id'
    | '/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_org'
    | '/_provider'
    | '/provider-invite'
    | '/scheduler-demo'
    | '/_org/org/$orgId'
    | '/_provider/provider/jobs'
    | '/_admin/admin/'
    | '/_org/org-onboarding/'
    | '/_org/org/'
    | '/_provider/provider-onboarding/'
    | '/_provider/provider/'
    | '/auth-org/no-organization/'
    | '/auth-org/signin/'
    | '/auth-provider/signin/'
    | '/auth/mfa/'
    | '/jobs/$id/'
    | '/_org/org/bu/$organizationBusinessUnitId'
    | '/_admin/admin/chat/'
    | '/_admin/admin/dashboard/'
    | '/_admin/admin/documents/'
    | '/_admin/admin/job-posts/'
    | '/_admin/admin/leads/'
    | '/_admin/admin/organizations/'
    | '/_admin/admin/provider-payouts/'
    | '/_admin/admin/provider-search/'
    | '/_admin/admin/referrals/'
    | '/_admin/admin/usage-billing/'
    | '/_admin/admin/users/'
    | '/_org/org/$orgId/'
    | '/_org/org/chat/'
    | '/_org/org/create/'
    | '/_org/org/facilities/'
    | '/_org/org/forms/'
    | '/_org/org/hiring-process/'
    | '/_org/org/home/'
    | '/_org/org/jobs/'
    | '/_org/org/provider-search/'
    | '/_org/org/providers/'
    | '/_org/org/settings/'
    | '/_org/org/team/'
    | '/_provider/provider/affiliations/'
    | '/_provider/provider/billing/'
    | '/_provider/provider/chat/'
    | '/_provider/provider/credentials/'
    | '/_provider/provider/documents/'
    | '/_provider/provider/home/'
    | '/_provider/provider/jobs/'
    | '/_provider/provider/procedure-log/'
    | '/_provider/provider/profile/'
    | '/_provider/provider/referrals/'
    | '/_provider/provider/settings/'
    | '/_provider/provider/shifts/'
    | '/_provider/provider/work-history/'
    | '/auth/signin/link/'
    | '/auth/signin/oauth/'
    | '/auth/signin/redirect/'
    | '/_admin/admin/job-posts/$jobPostId/'
    | '/_admin/admin/provider-profile/$userId/'
    | '/_admin/admin/usage-billing/$organizationBusinessUnitId/'
    | '/_admin/admin/users/$userId/'
    | '/_org/org/$orgId/chat/'
    | '/_org/org/$orgId/facilities/'
    | '/_org/org/$orgId/home/'
    | '/_org/org/$orgId/jobs/'
    | '/_org/org/$orgId/provider-search/'
    | '/_org/org/$orgId/providers/'
    | '/_org/org/$orgId/settings/'
    | '/_org/org/$orgId/team/'
    | '/_org/org/bu/$organizationBusinessUnitId/'
    | '/_org/org/jobs/offer/'
    | '/_org/org/jobs/post/'
    | '/_org/org/jobs/timesheets/'
    | '/_org/org/provider-profile/$userId/'
    | '/_org/org/providers/all/'
    | '/_org/org/providers/pools/'
    | '/_org/org/providers/shared/'
    | '/_org/org/team/roles/'
    | '/_provider/provider/jobs/$id/'
    | '/_provider/provider/jobs/active/'
    | '/_provider/provider/jobs/interests/'
    | '/_provider/provider/jobs/offers/'
    | '/_provider/provider/jobs/preferences/'
    | '/_provider/provider/jobs/recommended/'
    | '/_provider/provider/jobs/search/'
    | '/_provider/provider/jobs/timesheets/'
    | '/_provider/provider/shifts/preferences/'
    | '/_provider/provider/shifts/search/'
    | '/_admin/admin/organizations/$orgId/business-units/'
    | '/_org/org/$orgId/jobs/offer/'
    | '/_org/org/$orgId/jobs/post/'
    | '/_org/org/$orgId/jobs/timesheets/'
    | '/_org/org/$orgId/providers/all/'
    | '/_org/org/$orgId/providers/pools/'
    | '/_org/org/$orgId/team/roles/'
    | '/_org/org/bu/$organizationBusinessUnitId/billing/'
    | '/_org/org/bu/$organizationBusinessUnitId/chat/'
    | '/_org/org/bu/$organizationBusinessUnitId/facilities/'
    | '/_org/org/bu/$organizationBusinessUnitId/forms/'
    | '/_org/org/bu/$organizationBusinessUnitId/hiring-process/'
    | '/_org/org/bu/$organizationBusinessUnitId/home/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/'
    | '/_org/org/bu/$organizationBusinessUnitId/provider-search/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/'
    | '/_org/org/bu/$organizationBusinessUnitId/settings/'
    | '/_org/org/bu/$organizationBusinessUnitId/team/'
    | '/_org/org/jobs/offer/create/'
    | '/_org/org/jobs/post/create/'
    | '/_org/org/providers/pools/$id/'
    | '/_org/org/$orgId/jobs/offer/create/'
    | '/_org/org/$orgId/jobs/post/create/'
    | '/_org/org/$orgId/providers/pools/$id/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/post/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/timesheets/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/'
    | '/_org/org/bu/$organizationBusinessUnitId/provider-profile/$userId/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/affiliated/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/all/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/invitations/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/pools/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/shared/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/workspace/'
    | '/_org/org/bu/$organizationBusinessUnitId/team/roles/'
    | '/_org/org/jobs/offer/edit/$id/'
    | '/_org/org/jobs/post/dashboard/$id/'
    | '/_org/org/jobs/post/edit/$id/'
    | '/_admin/admin/organizations/$orgId/business-units/$businessUnitId/users/'
    | '/_org/org/$orgId/jobs/offer/edit/$id/'
    | '/_org/org/$orgId/jobs/post/dashboard/$id/'
    | '/_org/org/$orgId/jobs/post/edit/$id/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/create/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/post/create/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/'
    | '/_org/org/bu/$organizationBusinessUnitId/providers/pools/$id/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/'
    | '/_org/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  OrgRoute: typeof OrgRouteWithChildren
  ProviderRoute: typeof ProviderRouteWithChildren
  ProviderInviteRoute: typeof ProviderInviteRoute
  SchedulerDemoRoute: typeof SchedulerDemoRoute
  AuthOrgNoOrganizationIndexRoute: typeof AuthOrgNoOrganizationIndexRoute
  AuthOrgSigninIndexRoute: typeof AuthOrgSigninIndexRoute
  AuthProviderSigninIndexRoute: typeof AuthProviderSigninIndexRoute
  AuthMfaIndexRoute: typeof AuthMfaIndexRoute
  JobsIdIndexRoute: typeof JobsIdIndexRoute
  AuthSigninLinkIndexRoute: typeof AuthSigninLinkIndexRoute
  AuthSigninOauthIndexRoute: typeof AuthSigninOauthIndexRoute
  AuthSigninRedirectIndexRoute: typeof AuthSigninRedirectIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_org': {
      id: '/_org'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_provider': {
      id: '/_provider'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProviderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-invite': {
      id: '/provider-invite'
      path: '/provider-invite'
      fullPath: '/provider-invite'
      preLoaderRoute: typeof ProviderInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler-demo': {
      id: '/scheduler-demo'
      path: '/scheduler-demo'
      fullPath: '/scheduler-demo'
      preLoaderRoute: typeof SchedulerDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/admin/': {
      id: '/_admin/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminAdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_org/org-onboarding/': {
      id: '/_org/org-onboarding/'
      path: '/org-onboarding'
      fullPath: '/org-onboarding/'
      preLoaderRoute: typeof OrgOrgOnboardingIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/': {
      id: '/_org/org/'
      path: '/org'
      fullPath: '/org/'
      preLoaderRoute: typeof OrgOrgIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/$orgId': {
      id: '/_org/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof OrgOrgOrgIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_provider/provider-onboarding/': {
      id: '/_provider/provider-onboarding/'
      path: '/provider-onboarding'
      fullPath: '/provider-onboarding/'
      preLoaderRoute: typeof ProviderProviderOnboardingIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/': {
      id: '/_provider/provider/'
      path: '/provider'
      fullPath: '/provider/'
      preLoaderRoute: typeof ProviderProviderIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/jobs': {
      id: '/_provider/provider/jobs'
      path: '/provider/jobs'
      fullPath: '/provider/jobs'
      preLoaderRoute: typeof ProviderProviderJobsRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/auth-org/no-organization/': {
      id: '/auth-org/no-organization/'
      path: '/auth-org/no-organization'
      fullPath: '/auth-org/no-organization/'
      preLoaderRoute: typeof AuthOrgNoOrganizationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-org/signin/': {
      id: '/auth-org/signin/'
      path: '/auth-org/signin'
      fullPath: '/auth-org/signin/'
      preLoaderRoute: typeof AuthOrgSigninIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-provider/signin/': {
      id: '/auth-provider/signin/'
      path: '/auth-provider/signin'
      fullPath: '/auth-provider/signin/'
      preLoaderRoute: typeof AuthProviderSigninIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/mfa/': {
      id: '/auth/mfa/'
      path: '/auth/mfa'
      fullPath: '/auth/mfa/'
      preLoaderRoute: typeof AuthMfaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$id/': {
      id: '/jobs/$id/'
      path: '/jobs/$id'
      fullPath: '/jobs/$id/'
      preLoaderRoute: typeof JobsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/admin/chat/': {
      id: '/_admin/admin/chat/'
      path: '/admin/chat'
      fullPath: '/admin/chat/'
      preLoaderRoute: typeof AdminAdminChatIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/dashboard/': {
      id: '/_admin/admin/dashboard/'
      path: '/admin/dashboard'
      fullPath: '/admin/dashboard/'
      preLoaderRoute: typeof AdminAdminDashboardIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/documents/': {
      id: '/_admin/admin/documents/'
      path: '/admin/documents'
      fullPath: '/admin/documents/'
      preLoaderRoute: typeof AdminAdminDocumentsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/job-posts/': {
      id: '/_admin/admin/job-posts/'
      path: '/admin/job-posts'
      fullPath: '/admin/job-posts/'
      preLoaderRoute: typeof AdminAdminJobPostsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/leads/': {
      id: '/_admin/admin/leads/'
      path: '/admin/leads'
      fullPath: '/admin/leads/'
      preLoaderRoute: typeof AdminAdminLeadsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/organizations/': {
      id: '/_admin/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AdminAdminOrganizationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/provider-payouts/': {
      id: '/_admin/admin/provider-payouts/'
      path: '/admin/provider-payouts'
      fullPath: '/admin/provider-payouts/'
      preLoaderRoute: typeof AdminAdminProviderPayoutsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/provider-search/': {
      id: '/_admin/admin/provider-search/'
      path: '/admin/provider-search'
      fullPath: '/admin/provider-search/'
      preLoaderRoute: typeof AdminAdminProviderSearchIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/referrals/': {
      id: '/_admin/admin/referrals/'
      path: '/admin/referrals'
      fullPath: '/admin/referrals/'
      preLoaderRoute: typeof AdminAdminReferralsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/usage-billing/': {
      id: '/_admin/admin/usage-billing/'
      path: '/admin/usage-billing'
      fullPath: '/admin/usage-billing/'
      preLoaderRoute: typeof AdminAdminUsageBillingIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/users/': {
      id: '/_admin/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminAdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_org/org/$orgId/': {
      id: '/_org/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof OrgOrgOrgIdIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId': {
      id: '/_org/org/bu/$organizationBusinessUnitId'
      path: '/org/bu/$organizationBusinessUnitId'
      fullPath: '/org/bu/$organizationBusinessUnitId'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/chat/': {
      id: '/_org/org/chat/'
      path: '/org/chat'
      fullPath: '/org/chat/'
      preLoaderRoute: typeof OrgOrgChatIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/create/': {
      id: '/_org/org/create/'
      path: '/org/create'
      fullPath: '/org/create/'
      preLoaderRoute: typeof OrgOrgCreateIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/facilities/': {
      id: '/_org/org/facilities/'
      path: '/org/facilities'
      fullPath: '/org/facilities/'
      preLoaderRoute: typeof OrgOrgFacilitiesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/forms/': {
      id: '/_org/org/forms/'
      path: '/org/forms'
      fullPath: '/org/forms/'
      preLoaderRoute: typeof OrgOrgFormsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/hiring-process/': {
      id: '/_org/org/hiring-process/'
      path: '/org/hiring-process'
      fullPath: '/org/hiring-process/'
      preLoaderRoute: typeof OrgOrgHiringProcessIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/home/': {
      id: '/_org/org/home/'
      path: '/org/home'
      fullPath: '/org/home/'
      preLoaderRoute: typeof OrgOrgHomeIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/jobs/': {
      id: '/_org/org/jobs/'
      path: '/org/jobs'
      fullPath: '/org/jobs/'
      preLoaderRoute: typeof OrgOrgJobsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/provider-search/': {
      id: '/_org/org/provider-search/'
      path: '/org/provider-search'
      fullPath: '/org/provider-search/'
      preLoaderRoute: typeof OrgOrgProviderSearchIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/providers/': {
      id: '/_org/org/providers/'
      path: '/org/providers'
      fullPath: '/org/providers/'
      preLoaderRoute: typeof OrgOrgProvidersIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/settings/': {
      id: '/_org/org/settings/'
      path: '/org/settings'
      fullPath: '/org/settings/'
      preLoaderRoute: typeof OrgOrgSettingsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/team/': {
      id: '/_org/org/team/'
      path: '/org/team'
      fullPath: '/org/team/'
      preLoaderRoute: typeof OrgOrgTeamIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_provider/provider/affiliations/': {
      id: '/_provider/provider/affiliations/'
      path: '/provider/affiliations'
      fullPath: '/provider/affiliations/'
      preLoaderRoute: typeof ProviderProviderAffiliationsIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/billing/': {
      id: '/_provider/provider/billing/'
      path: '/provider/billing'
      fullPath: '/provider/billing/'
      preLoaderRoute: typeof ProviderProviderBillingIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/chat/': {
      id: '/_provider/provider/chat/'
      path: '/provider/chat'
      fullPath: '/provider/chat/'
      preLoaderRoute: typeof ProviderProviderChatIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/credentials/': {
      id: '/_provider/provider/credentials/'
      path: '/provider/credentials'
      fullPath: '/provider/credentials/'
      preLoaderRoute: typeof ProviderProviderCredentialsIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/documents/': {
      id: '/_provider/provider/documents/'
      path: '/provider/documents'
      fullPath: '/provider/documents/'
      preLoaderRoute: typeof ProviderProviderDocumentsIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/home/': {
      id: '/_provider/provider/home/'
      path: '/provider/home'
      fullPath: '/provider/home/'
      preLoaderRoute: typeof ProviderProviderHomeIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/jobs/': {
      id: '/_provider/provider/jobs/'
      path: '/'
      fullPath: '/provider/jobs/'
      preLoaderRoute: typeof ProviderProviderJobsIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/procedure-log/': {
      id: '/_provider/provider/procedure-log/'
      path: '/provider/procedure-log'
      fullPath: '/provider/procedure-log/'
      preLoaderRoute: typeof ProviderProviderProcedureLogIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/profile/': {
      id: '/_provider/provider/profile/'
      path: '/provider/profile'
      fullPath: '/provider/profile/'
      preLoaderRoute: typeof ProviderProviderProfileIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/referrals/': {
      id: '/_provider/provider/referrals/'
      path: '/provider/referrals'
      fullPath: '/provider/referrals/'
      preLoaderRoute: typeof ProviderProviderReferralsIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/settings/': {
      id: '/_provider/provider/settings/'
      path: '/provider/settings'
      fullPath: '/provider/settings/'
      preLoaderRoute: typeof ProviderProviderSettingsIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/shifts/': {
      id: '/_provider/provider/shifts/'
      path: '/provider/shifts'
      fullPath: '/provider/shifts/'
      preLoaderRoute: typeof ProviderProviderShiftsIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/work-history/': {
      id: '/_provider/provider/work-history/'
      path: '/provider/work-history'
      fullPath: '/provider/work-history/'
      preLoaderRoute: typeof ProviderProviderWorkHistoryIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/auth/signin/link/': {
      id: '/auth/signin/link/'
      path: '/auth/signin/link'
      fullPath: '/auth/signin/link/'
      preLoaderRoute: typeof AuthSigninLinkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin/oauth/': {
      id: '/auth/signin/oauth/'
      path: '/auth/signin/oauth'
      fullPath: '/auth/signin/oauth/'
      preLoaderRoute: typeof AuthSigninOauthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin/redirect/': {
      id: '/auth/signin/redirect/'
      path: '/auth/signin/redirect'
      fullPath: '/auth/signin/redirect/'
      preLoaderRoute: typeof AuthSigninRedirectIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/admin/job-posts/$jobPostId/': {
      id: '/_admin/admin/job-posts/$jobPostId/'
      path: '/admin/job-posts/$jobPostId'
      fullPath: '/admin/job-posts/$jobPostId/'
      preLoaderRoute: typeof AdminAdminJobPostsJobPostIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/provider-profile/$userId/': {
      id: '/_admin/admin/provider-profile/$userId/'
      path: '/admin/provider-profile/$userId'
      fullPath: '/admin/provider-profile/$userId/'
      preLoaderRoute: typeof AdminAdminProviderProfileUserIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/usage-billing/$organizationBusinessUnitId/': {
      id: '/_admin/admin/usage-billing/$organizationBusinessUnitId/'
      path: '/admin/usage-billing/$organizationBusinessUnitId'
      fullPath: '/admin/usage-billing/$organizationBusinessUnitId/'
      preLoaderRoute: typeof AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/users/$userId/': {
      id: '/_admin/admin/users/$userId/'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof AdminAdminUsersUserIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_org/org/$orgId/chat/': {
      id: '/_org/org/$orgId/chat/'
      path: '/chat'
      fullPath: '/org/$orgId/chat/'
      preLoaderRoute: typeof OrgOrgOrgIdChatIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/facilities/': {
      id: '/_org/org/$orgId/facilities/'
      path: '/facilities'
      fullPath: '/org/$orgId/facilities/'
      preLoaderRoute: typeof OrgOrgOrgIdFacilitiesIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/home/': {
      id: '/_org/org/$orgId/home/'
      path: '/home'
      fullPath: '/org/$orgId/home/'
      preLoaderRoute: typeof OrgOrgOrgIdHomeIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/jobs/': {
      id: '/_org/org/$orgId/jobs/'
      path: '/jobs'
      fullPath: '/org/$orgId/jobs/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/provider-search/': {
      id: '/_org/org/$orgId/provider-search/'
      path: '/provider-search'
      fullPath: '/org/$orgId/provider-search/'
      preLoaderRoute: typeof OrgOrgOrgIdProviderSearchIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/providers/': {
      id: '/_org/org/$orgId/providers/'
      path: '/providers'
      fullPath: '/org/$orgId/providers/'
      preLoaderRoute: typeof OrgOrgOrgIdProvidersIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/settings/': {
      id: '/_org/org/$orgId/settings/'
      path: '/settings'
      fullPath: '/org/$orgId/settings/'
      preLoaderRoute: typeof OrgOrgOrgIdSettingsIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/team/': {
      id: '/_org/org/$orgId/team/'
      path: '/team'
      fullPath: '/org/$orgId/team/'
      preLoaderRoute: typeof OrgOrgOrgIdTeamIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/'
      path: '/'
      fullPath: '/org/bu/$organizationBusinessUnitId/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/jobs/offer/': {
      id: '/_org/org/jobs/offer/'
      path: '/org/jobs/offer'
      fullPath: '/org/jobs/offer/'
      preLoaderRoute: typeof OrgOrgJobsOfferIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/jobs/post/': {
      id: '/_org/org/jobs/post/'
      path: '/org/jobs/post'
      fullPath: '/org/jobs/post/'
      preLoaderRoute: typeof OrgOrgJobsPostIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/jobs/timesheets/': {
      id: '/_org/org/jobs/timesheets/'
      path: '/org/jobs/timesheets'
      fullPath: '/org/jobs/timesheets/'
      preLoaderRoute: typeof OrgOrgJobsTimesheetsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/provider-profile/$userId/': {
      id: '/_org/org/provider-profile/$userId/'
      path: '/org/provider-profile/$userId'
      fullPath: '/org/provider-profile/$userId/'
      preLoaderRoute: typeof OrgOrgProviderProfileUserIdIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/providers/all/': {
      id: '/_org/org/providers/all/'
      path: '/org/providers/all'
      fullPath: '/org/providers/all/'
      preLoaderRoute: typeof OrgOrgProvidersAllIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/providers/pools/': {
      id: '/_org/org/providers/pools/'
      path: '/org/providers/pools'
      fullPath: '/org/providers/pools/'
      preLoaderRoute: typeof OrgOrgProvidersPoolsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/providers/shared/': {
      id: '/_org/org/providers/shared/'
      path: '/org/providers/shared'
      fullPath: '/org/providers/shared/'
      preLoaderRoute: typeof OrgOrgProvidersSharedIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/team/roles/': {
      id: '/_org/org/team/roles/'
      path: '/org/team/roles'
      fullPath: '/org/team/roles/'
      preLoaderRoute: typeof OrgOrgTeamRolesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_provider/provider/jobs/$id/': {
      id: '/_provider/provider/jobs/$id/'
      path: '/$id'
      fullPath: '/provider/jobs/$id/'
      preLoaderRoute: typeof ProviderProviderJobsIdIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/jobs/active/': {
      id: '/_provider/provider/jobs/active/'
      path: '/active'
      fullPath: '/provider/jobs/active/'
      preLoaderRoute: typeof ProviderProviderJobsActiveIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/jobs/interests/': {
      id: '/_provider/provider/jobs/interests/'
      path: '/interests'
      fullPath: '/provider/jobs/interests/'
      preLoaderRoute: typeof ProviderProviderJobsInterestsIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/jobs/offers/': {
      id: '/_provider/provider/jobs/offers/'
      path: '/offers'
      fullPath: '/provider/jobs/offers/'
      preLoaderRoute: typeof ProviderProviderJobsOffersIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/jobs/preferences/': {
      id: '/_provider/provider/jobs/preferences/'
      path: '/preferences'
      fullPath: '/provider/jobs/preferences/'
      preLoaderRoute: typeof ProviderProviderJobsPreferencesIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/jobs/recommended/': {
      id: '/_provider/provider/jobs/recommended/'
      path: '/recommended'
      fullPath: '/provider/jobs/recommended/'
      preLoaderRoute: typeof ProviderProviderJobsRecommendedIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/jobs/search/': {
      id: '/_provider/provider/jobs/search/'
      path: '/search'
      fullPath: '/provider/jobs/search/'
      preLoaderRoute: typeof ProviderProviderJobsSearchIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/jobs/timesheets/': {
      id: '/_provider/provider/jobs/timesheets/'
      path: '/timesheets'
      fullPath: '/provider/jobs/timesheets/'
      preLoaderRoute: typeof ProviderProviderJobsTimesheetsIndexRouteImport
      parentRoute: typeof ProviderProviderJobsRoute
    }
    '/_provider/provider/shifts/preferences/': {
      id: '/_provider/provider/shifts/preferences/'
      path: '/provider/shifts/preferences'
      fullPath: '/provider/shifts/preferences/'
      preLoaderRoute: typeof ProviderProviderShiftsPreferencesIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_provider/provider/shifts/search/': {
      id: '/_provider/provider/shifts/search/'
      path: '/provider/shifts/search'
      fullPath: '/provider/shifts/search/'
      preLoaderRoute: typeof ProviderProviderShiftsSearchIndexRouteImport
      parentRoute: typeof ProviderRoute
    }
    '/_admin/admin/organizations/$orgId/business-units/': {
      id: '/_admin/admin/organizations/$orgId/business-units/'
      path: '/admin/organizations/$orgId/business-units'
      fullPath: '/admin/organizations/$orgId/business-units/'
      preLoaderRoute: typeof AdminAdminOrganizationsOrgIdBusinessUnitsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_org/org/$orgId/jobs/offer/': {
      id: '/_org/org/$orgId/jobs/offer/'
      path: '/jobs/offer'
      fullPath: '/org/$orgId/jobs/offer/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsOfferIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/jobs/post/': {
      id: '/_org/org/$orgId/jobs/post/'
      path: '/jobs/post'
      fullPath: '/org/$orgId/jobs/post/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsPostIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/jobs/timesheets/': {
      id: '/_org/org/$orgId/jobs/timesheets/'
      path: '/jobs/timesheets'
      fullPath: '/org/$orgId/jobs/timesheets/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsTimesheetsIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/providers/all/': {
      id: '/_org/org/$orgId/providers/all/'
      path: '/providers/all'
      fullPath: '/org/$orgId/providers/all/'
      preLoaderRoute: typeof OrgOrgOrgIdProvidersAllIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/providers/pools/': {
      id: '/_org/org/$orgId/providers/pools/'
      path: '/providers/pools'
      fullPath: '/org/$orgId/providers/pools/'
      preLoaderRoute: typeof OrgOrgOrgIdProvidersPoolsIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/team/roles/': {
      id: '/_org/org/$orgId/team/roles/'
      path: '/team/roles'
      fullPath: '/org/$orgId/team/roles/'
      preLoaderRoute: typeof OrgOrgOrgIdTeamRolesIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/billing/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/billing/'
      path: '/billing'
      fullPath: '/org/bu/$organizationBusinessUnitId/billing/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdBillingIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/chat/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/chat/'
      path: '/chat'
      fullPath: '/org/bu/$organizationBusinessUnitId/chat/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdChatIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/facilities/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/facilities/'
      path: '/facilities'
      fullPath: '/org/bu/$organizationBusinessUnitId/facilities/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/forms/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/forms/'
      path: '/forms'
      fullPath: '/org/bu/$organizationBusinessUnitId/forms/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdFormsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/hiring-process/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/hiring-process/'
      path: '/hiring-process'
      fullPath: '/org/bu/$organizationBusinessUnitId/hiring-process/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/home/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/home/'
      path: '/home'
      fullPath: '/org/bu/$organizationBusinessUnitId/home/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdHomeIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/'
      path: '/jobs'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/provider-search/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/provider-search/'
      path: '/provider-search'
      fullPath: '/org/bu/$organizationBusinessUnitId/provider-search/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/'
      path: '/providers'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/settings/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/settings/'
      path: '/settings'
      fullPath: '/org/bu/$organizationBusinessUnitId/settings/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/team/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/team/'
      path: '/team'
      fullPath: '/org/bu/$organizationBusinessUnitId/team/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdTeamIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/jobs/offer/create/': {
      id: '/_org/org/jobs/offer/create/'
      path: '/org/jobs/offer/create'
      fullPath: '/org/jobs/offer/create/'
      preLoaderRoute: typeof OrgOrgJobsOfferCreateIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/jobs/post/create/': {
      id: '/_org/org/jobs/post/create/'
      path: '/org/jobs/post/create'
      fullPath: '/org/jobs/post/create/'
      preLoaderRoute: typeof OrgOrgJobsPostCreateIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/providers/pools/$id/': {
      id: '/_org/org/providers/pools/$id/'
      path: '/org/providers/pools/$id'
      fullPath: '/org/providers/pools/$id/'
      preLoaderRoute: typeof OrgOrgProvidersPoolsIdIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/$orgId/jobs/offer/create/': {
      id: '/_org/org/$orgId/jobs/offer/create/'
      path: '/jobs/offer/create'
      fullPath: '/org/$orgId/jobs/offer/create/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsOfferCreateIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/jobs/post/create/': {
      id: '/_org/org/$orgId/jobs/post/create/'
      path: '/jobs/post/create'
      fullPath: '/org/$orgId/jobs/post/create/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsPostCreateIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/providers/pools/$id/': {
      id: '/_org/org/$orgId/providers/pools/$id/'
      path: '/providers/pools/$id'
      fullPath: '/org/$orgId/providers/pools/$id/'
      preLoaderRoute: typeof OrgOrgOrgIdProvidersPoolsIdIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/'
      path: '/jobs/offer'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/offer/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/post/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/post/'
      path: '/jobs/post'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/post/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/timesheets/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/timesheets/'
      path: '/jobs/timesheets'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/timesheets/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/'
      path: '/jobs/wage-sets'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/provider-profile/$userId/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/provider-profile/$userId/'
      path: '/provider-profile/$userId'
      fullPath: '/org/bu/$organizationBusinessUnitId/provider-profile/$userId/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/affiliated/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/affiliated/'
      path: '/providers/affiliated'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/affiliated/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/all/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/all/'
      path: '/providers/all'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/all/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/'
      path: '/providers/credentials'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/credentials/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/invitations/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/invitations/'
      path: '/providers/invitations'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/invitations/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/pools/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/pools/'
      path: '/providers/pools'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/pools/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/shared/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/shared/'
      path: '/providers/shared'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/shared/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/workspace/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/workspace/'
      path: '/providers/workspace'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/workspace/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/team/roles/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/team/roles/'
      path: '/team/roles'
      fullPath: '/org/bu/$organizationBusinessUnitId/team/roles/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/jobs/offer/edit/$id/': {
      id: '/_org/org/jobs/offer/edit/$id/'
      path: '/org/jobs/offer/edit/$id'
      fullPath: '/org/jobs/offer/edit/$id/'
      preLoaderRoute: typeof OrgOrgJobsOfferEditIdIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/jobs/post/dashboard/$id/': {
      id: '/_org/org/jobs/post/dashboard/$id/'
      path: '/org/jobs/post/dashboard/$id'
      fullPath: '/org/jobs/post/dashboard/$id/'
      preLoaderRoute: typeof OrgOrgJobsPostDashboardIdIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/jobs/post/edit/$id/': {
      id: '/_org/org/jobs/post/edit/$id/'
      path: '/org/jobs/post/edit/$id'
      fullPath: '/org/jobs/post/edit/$id/'
      preLoaderRoute: typeof OrgOrgJobsPostEditIdIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_admin/admin/organizations/$orgId/business-units/$businessUnitId/users/': {
      id: '/_admin/admin/organizations/$orgId/business-units/$businessUnitId/users/'
      path: '/admin/organizations/$orgId/business-units/$businessUnitId/users'
      fullPath: '/admin/organizations/$orgId/business-units/$businessUnitId/users/'
      preLoaderRoute: typeof AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_org/org/$orgId/jobs/offer/edit/$id/': {
      id: '/_org/org/$orgId/jobs/offer/edit/$id/'
      path: '/jobs/offer/edit/$id'
      fullPath: '/org/$orgId/jobs/offer/edit/$id/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsOfferEditIdIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/jobs/post/dashboard/$id/': {
      id: '/_org/org/$orgId/jobs/post/dashboard/$id/'
      path: '/jobs/post/dashboard/$id'
      fullPath: '/org/$orgId/jobs/post/dashboard/$id/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsPostDashboardIdIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/$orgId/jobs/post/edit/$id/': {
      id: '/_org/org/$orgId/jobs/post/edit/$id/'
      path: '/jobs/post/edit/$id'
      fullPath: '/org/$orgId/jobs/post/edit/$id/'
      preLoaderRoute: typeof OrgOrgOrgIdJobsPostEditIdIndexRouteImport
      parentRoute: typeof OrgOrgOrgIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/create/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/create/'
      path: '/jobs/offer/create'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/offer/create/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/post/create/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/post/create/'
      path: '/jobs/post/create'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/post/create/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/'
      path: '/jobs/wage-sets/$organizationWageSetId'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/'
      path: '/providers/credentials/$affiliationId'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/providers/pools/$id/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/providers/pools/$id/'
      path: '/providers/pools/$id'
      fullPath: '/org/bu/$organizationBusinessUnitId/providers/pools/$id/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/'
      path: '/jobs/offer/edit/$id'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/'
      path: '/jobs/post/dashboard/$id'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/post/dashboard/$id/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
    '/_org/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/': {
      id: '/_org/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/'
      path: '/jobs/post/edit/$id'
      fullPath: '/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/'
      preLoaderRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRouteImport
      parentRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAdminIndexRoute: typeof AdminAdminIndexRoute
  AdminAdminChatIndexRoute: typeof AdminAdminChatIndexRoute
  AdminAdminDashboardIndexRoute: typeof AdminAdminDashboardIndexRoute
  AdminAdminDocumentsIndexRoute: typeof AdminAdminDocumentsIndexRoute
  AdminAdminJobPostsIndexRoute: typeof AdminAdminJobPostsIndexRoute
  AdminAdminLeadsIndexRoute: typeof AdminAdminLeadsIndexRoute
  AdminAdminOrganizationsIndexRoute: typeof AdminAdminOrganizationsIndexRoute
  AdminAdminProviderPayoutsIndexRoute: typeof AdminAdminProviderPayoutsIndexRoute
  AdminAdminProviderSearchIndexRoute: typeof AdminAdminProviderSearchIndexRoute
  AdminAdminReferralsIndexRoute: typeof AdminAdminReferralsIndexRoute
  AdminAdminUsageBillingIndexRoute: typeof AdminAdminUsageBillingIndexRoute
  AdminAdminUsersIndexRoute: typeof AdminAdminUsersIndexRoute
  AdminAdminJobPostsJobPostIdIndexRoute: typeof AdminAdminJobPostsJobPostIdIndexRoute
  AdminAdminProviderProfileUserIdIndexRoute: typeof AdminAdminProviderProfileUserIdIndexRoute
  AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute: typeof AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute
  AdminAdminUsersUserIdIndexRoute: typeof AdminAdminUsersUserIdIndexRoute
  AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute: typeof AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute
  AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute: typeof AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminIndexRoute: AdminAdminIndexRoute,
  AdminAdminChatIndexRoute: AdminAdminChatIndexRoute,
  AdminAdminDashboardIndexRoute: AdminAdminDashboardIndexRoute,
  AdminAdminDocumentsIndexRoute: AdminAdminDocumentsIndexRoute,
  AdminAdminJobPostsIndexRoute: AdminAdminJobPostsIndexRoute,
  AdminAdminLeadsIndexRoute: AdminAdminLeadsIndexRoute,
  AdminAdminOrganizationsIndexRoute: AdminAdminOrganizationsIndexRoute,
  AdminAdminProviderPayoutsIndexRoute: AdminAdminProviderPayoutsIndexRoute,
  AdminAdminProviderSearchIndexRoute: AdminAdminProviderSearchIndexRoute,
  AdminAdminReferralsIndexRoute: AdminAdminReferralsIndexRoute,
  AdminAdminUsageBillingIndexRoute: AdminAdminUsageBillingIndexRoute,
  AdminAdminUsersIndexRoute: AdminAdminUsersIndexRoute,
  AdminAdminJobPostsJobPostIdIndexRoute: AdminAdminJobPostsJobPostIdIndexRoute,
  AdminAdminProviderProfileUserIdIndexRoute:
    AdminAdminProviderProfileUserIdIndexRoute,
  AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute:
    AdminAdminUsageBillingOrganizationBusinessUnitIdIndexRoute,
  AdminAdminUsersUserIdIndexRoute: AdminAdminUsersUserIdIndexRoute,
  AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute:
    AdminAdminOrganizationsOrgIdBusinessUnitsIndexRoute,
  AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute:
    AdminAdminOrganizationsOrgIdBusinessUnitsBusinessUnitIdUsersIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface OrgOrgOrgIdRouteChildren {
  OrgOrgOrgIdIndexRoute: typeof OrgOrgOrgIdIndexRoute
  OrgOrgOrgIdChatIndexRoute: typeof OrgOrgOrgIdChatIndexRoute
  OrgOrgOrgIdFacilitiesIndexRoute: typeof OrgOrgOrgIdFacilitiesIndexRoute
  OrgOrgOrgIdHomeIndexRoute: typeof OrgOrgOrgIdHomeIndexRoute
  OrgOrgOrgIdJobsIndexRoute: typeof OrgOrgOrgIdJobsIndexRoute
  OrgOrgOrgIdProviderSearchIndexRoute: typeof OrgOrgOrgIdProviderSearchIndexRoute
  OrgOrgOrgIdProvidersIndexRoute: typeof OrgOrgOrgIdProvidersIndexRoute
  OrgOrgOrgIdSettingsIndexRoute: typeof OrgOrgOrgIdSettingsIndexRoute
  OrgOrgOrgIdTeamIndexRoute: typeof OrgOrgOrgIdTeamIndexRoute
  OrgOrgOrgIdJobsOfferIndexRoute: typeof OrgOrgOrgIdJobsOfferIndexRoute
  OrgOrgOrgIdJobsPostIndexRoute: typeof OrgOrgOrgIdJobsPostIndexRoute
  OrgOrgOrgIdJobsTimesheetsIndexRoute: typeof OrgOrgOrgIdJobsTimesheetsIndexRoute
  OrgOrgOrgIdProvidersAllIndexRoute: typeof OrgOrgOrgIdProvidersAllIndexRoute
  OrgOrgOrgIdProvidersPoolsIndexRoute: typeof OrgOrgOrgIdProvidersPoolsIndexRoute
  OrgOrgOrgIdTeamRolesIndexRoute: typeof OrgOrgOrgIdTeamRolesIndexRoute
  OrgOrgOrgIdJobsOfferCreateIndexRoute: typeof OrgOrgOrgIdJobsOfferCreateIndexRoute
  OrgOrgOrgIdJobsPostCreateIndexRoute: typeof OrgOrgOrgIdJobsPostCreateIndexRoute
  OrgOrgOrgIdProvidersPoolsIdIndexRoute: typeof OrgOrgOrgIdProvidersPoolsIdIndexRoute
  OrgOrgOrgIdJobsOfferEditIdIndexRoute: typeof OrgOrgOrgIdJobsOfferEditIdIndexRoute
  OrgOrgOrgIdJobsPostDashboardIdIndexRoute: typeof OrgOrgOrgIdJobsPostDashboardIdIndexRoute
  OrgOrgOrgIdJobsPostEditIdIndexRoute: typeof OrgOrgOrgIdJobsPostEditIdIndexRoute
}

const OrgOrgOrgIdRouteChildren: OrgOrgOrgIdRouteChildren = {
  OrgOrgOrgIdIndexRoute: OrgOrgOrgIdIndexRoute,
  OrgOrgOrgIdChatIndexRoute: OrgOrgOrgIdChatIndexRoute,
  OrgOrgOrgIdFacilitiesIndexRoute: OrgOrgOrgIdFacilitiesIndexRoute,
  OrgOrgOrgIdHomeIndexRoute: OrgOrgOrgIdHomeIndexRoute,
  OrgOrgOrgIdJobsIndexRoute: OrgOrgOrgIdJobsIndexRoute,
  OrgOrgOrgIdProviderSearchIndexRoute: OrgOrgOrgIdProviderSearchIndexRoute,
  OrgOrgOrgIdProvidersIndexRoute: OrgOrgOrgIdProvidersIndexRoute,
  OrgOrgOrgIdSettingsIndexRoute: OrgOrgOrgIdSettingsIndexRoute,
  OrgOrgOrgIdTeamIndexRoute: OrgOrgOrgIdTeamIndexRoute,
  OrgOrgOrgIdJobsOfferIndexRoute: OrgOrgOrgIdJobsOfferIndexRoute,
  OrgOrgOrgIdJobsPostIndexRoute: OrgOrgOrgIdJobsPostIndexRoute,
  OrgOrgOrgIdJobsTimesheetsIndexRoute: OrgOrgOrgIdJobsTimesheetsIndexRoute,
  OrgOrgOrgIdProvidersAllIndexRoute: OrgOrgOrgIdProvidersAllIndexRoute,
  OrgOrgOrgIdProvidersPoolsIndexRoute: OrgOrgOrgIdProvidersPoolsIndexRoute,
  OrgOrgOrgIdTeamRolesIndexRoute: OrgOrgOrgIdTeamRolesIndexRoute,
  OrgOrgOrgIdJobsOfferCreateIndexRoute: OrgOrgOrgIdJobsOfferCreateIndexRoute,
  OrgOrgOrgIdJobsPostCreateIndexRoute: OrgOrgOrgIdJobsPostCreateIndexRoute,
  OrgOrgOrgIdProvidersPoolsIdIndexRoute: OrgOrgOrgIdProvidersPoolsIdIndexRoute,
  OrgOrgOrgIdJobsOfferEditIdIndexRoute: OrgOrgOrgIdJobsOfferEditIdIndexRoute,
  OrgOrgOrgIdJobsPostDashboardIdIndexRoute:
    OrgOrgOrgIdJobsPostDashboardIdIndexRoute,
  OrgOrgOrgIdJobsPostEditIdIndexRoute: OrgOrgOrgIdJobsPostEditIdIndexRoute,
}

const OrgOrgOrgIdRouteWithChildren = OrgOrgOrgIdRoute._addFileChildren(
  OrgOrgOrgIdRouteChildren,
)

interface OrgOrgBuOrganizationBusinessUnitIdRouteChildren {
  OrgOrgBuOrganizationBusinessUnitIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute: typeof OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute
}

const OrgOrgBuOrganizationBusinessUnitIdRouteChildren: OrgOrgBuOrganizationBusinessUnitIdRouteChildren =
  {
    OrgOrgBuOrganizationBusinessUnitIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdBillingIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdChatIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdFacilitiesIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdFormsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdHiringProcessIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdHomeIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProviderSearchIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdSettingsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdTeamIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsOfferIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsPostIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsTimesheetsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProviderProfileUserIdIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersAffiliatedIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersAllIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersInvitationsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersSharedIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersWorkspaceIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdTeamRolesIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsOfferCreateIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsPostCreateIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsWageSetsOrganizationWageSetIdIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersCredentialsAffiliationIdIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdProvidersPoolsIdIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsOfferEditIdIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsPostDashboardIdIndexRoute,
    OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute:
      OrgOrgBuOrganizationBusinessUnitIdJobsPostEditIdIndexRoute,
  }

const OrgOrgBuOrganizationBusinessUnitIdRouteWithChildren =
  OrgOrgBuOrganizationBusinessUnitIdRoute._addFileChildren(
    OrgOrgBuOrganizationBusinessUnitIdRouteChildren,
  )

interface OrgRouteChildren {
  OrgOrgOrgIdRoute: typeof OrgOrgOrgIdRouteWithChildren
  OrgOrgOnboardingIndexRoute: typeof OrgOrgOnboardingIndexRoute
  OrgOrgIndexRoute: typeof OrgOrgIndexRoute
  OrgOrgBuOrganizationBusinessUnitIdRoute: typeof OrgOrgBuOrganizationBusinessUnitIdRouteWithChildren
  OrgOrgChatIndexRoute: typeof OrgOrgChatIndexRoute
  OrgOrgCreateIndexRoute: typeof OrgOrgCreateIndexRoute
  OrgOrgFacilitiesIndexRoute: typeof OrgOrgFacilitiesIndexRoute
  OrgOrgFormsIndexRoute: typeof OrgOrgFormsIndexRoute
  OrgOrgHiringProcessIndexRoute: typeof OrgOrgHiringProcessIndexRoute
  OrgOrgHomeIndexRoute: typeof OrgOrgHomeIndexRoute
  OrgOrgJobsIndexRoute: typeof OrgOrgJobsIndexRoute
  OrgOrgProviderSearchIndexRoute: typeof OrgOrgProviderSearchIndexRoute
  OrgOrgProvidersIndexRoute: typeof OrgOrgProvidersIndexRoute
  OrgOrgSettingsIndexRoute: typeof OrgOrgSettingsIndexRoute
  OrgOrgTeamIndexRoute: typeof OrgOrgTeamIndexRoute
  OrgOrgJobsOfferIndexRoute: typeof OrgOrgJobsOfferIndexRoute
  OrgOrgJobsPostIndexRoute: typeof OrgOrgJobsPostIndexRoute
  OrgOrgJobsTimesheetsIndexRoute: typeof OrgOrgJobsTimesheetsIndexRoute
  OrgOrgProviderProfileUserIdIndexRoute: typeof OrgOrgProviderProfileUserIdIndexRoute
  OrgOrgProvidersAllIndexRoute: typeof OrgOrgProvidersAllIndexRoute
  OrgOrgProvidersPoolsIndexRoute: typeof OrgOrgProvidersPoolsIndexRoute
  OrgOrgProvidersSharedIndexRoute: typeof OrgOrgProvidersSharedIndexRoute
  OrgOrgTeamRolesIndexRoute: typeof OrgOrgTeamRolesIndexRoute
  OrgOrgJobsOfferCreateIndexRoute: typeof OrgOrgJobsOfferCreateIndexRoute
  OrgOrgJobsPostCreateIndexRoute: typeof OrgOrgJobsPostCreateIndexRoute
  OrgOrgProvidersPoolsIdIndexRoute: typeof OrgOrgProvidersPoolsIdIndexRoute
  OrgOrgJobsOfferEditIdIndexRoute: typeof OrgOrgJobsOfferEditIdIndexRoute
  OrgOrgJobsPostDashboardIdIndexRoute: typeof OrgOrgJobsPostDashboardIdIndexRoute
  OrgOrgJobsPostEditIdIndexRoute: typeof OrgOrgJobsPostEditIdIndexRoute
}

const OrgRouteChildren: OrgRouteChildren = {
  OrgOrgOrgIdRoute: OrgOrgOrgIdRouteWithChildren,
  OrgOrgOnboardingIndexRoute: OrgOrgOnboardingIndexRoute,
  OrgOrgIndexRoute: OrgOrgIndexRoute,
  OrgOrgBuOrganizationBusinessUnitIdRoute:
    OrgOrgBuOrganizationBusinessUnitIdRouteWithChildren,
  OrgOrgChatIndexRoute: OrgOrgChatIndexRoute,
  OrgOrgCreateIndexRoute: OrgOrgCreateIndexRoute,
  OrgOrgFacilitiesIndexRoute: OrgOrgFacilitiesIndexRoute,
  OrgOrgFormsIndexRoute: OrgOrgFormsIndexRoute,
  OrgOrgHiringProcessIndexRoute: OrgOrgHiringProcessIndexRoute,
  OrgOrgHomeIndexRoute: OrgOrgHomeIndexRoute,
  OrgOrgJobsIndexRoute: OrgOrgJobsIndexRoute,
  OrgOrgProviderSearchIndexRoute: OrgOrgProviderSearchIndexRoute,
  OrgOrgProvidersIndexRoute: OrgOrgProvidersIndexRoute,
  OrgOrgSettingsIndexRoute: OrgOrgSettingsIndexRoute,
  OrgOrgTeamIndexRoute: OrgOrgTeamIndexRoute,
  OrgOrgJobsOfferIndexRoute: OrgOrgJobsOfferIndexRoute,
  OrgOrgJobsPostIndexRoute: OrgOrgJobsPostIndexRoute,
  OrgOrgJobsTimesheetsIndexRoute: OrgOrgJobsTimesheetsIndexRoute,
  OrgOrgProviderProfileUserIdIndexRoute: OrgOrgProviderProfileUserIdIndexRoute,
  OrgOrgProvidersAllIndexRoute: OrgOrgProvidersAllIndexRoute,
  OrgOrgProvidersPoolsIndexRoute: OrgOrgProvidersPoolsIndexRoute,
  OrgOrgProvidersSharedIndexRoute: OrgOrgProvidersSharedIndexRoute,
  OrgOrgTeamRolesIndexRoute: OrgOrgTeamRolesIndexRoute,
  OrgOrgJobsOfferCreateIndexRoute: OrgOrgJobsOfferCreateIndexRoute,
  OrgOrgJobsPostCreateIndexRoute: OrgOrgJobsPostCreateIndexRoute,
  OrgOrgProvidersPoolsIdIndexRoute: OrgOrgProvidersPoolsIdIndexRoute,
  OrgOrgJobsOfferEditIdIndexRoute: OrgOrgJobsOfferEditIdIndexRoute,
  OrgOrgJobsPostDashboardIdIndexRoute: OrgOrgJobsPostDashboardIdIndexRoute,
  OrgOrgJobsPostEditIdIndexRoute: OrgOrgJobsPostEditIdIndexRoute,
}

const OrgRouteWithChildren = OrgRoute._addFileChildren(OrgRouteChildren)

interface ProviderProviderJobsRouteChildren {
  ProviderProviderJobsIndexRoute: typeof ProviderProviderJobsIndexRoute
  ProviderProviderJobsIdIndexRoute: typeof ProviderProviderJobsIdIndexRoute
  ProviderProviderJobsActiveIndexRoute: typeof ProviderProviderJobsActiveIndexRoute
  ProviderProviderJobsInterestsIndexRoute: typeof ProviderProviderJobsInterestsIndexRoute
  ProviderProviderJobsOffersIndexRoute: typeof ProviderProviderJobsOffersIndexRoute
  ProviderProviderJobsPreferencesIndexRoute: typeof ProviderProviderJobsPreferencesIndexRoute
  ProviderProviderJobsRecommendedIndexRoute: typeof ProviderProviderJobsRecommendedIndexRoute
  ProviderProviderJobsSearchIndexRoute: typeof ProviderProviderJobsSearchIndexRoute
  ProviderProviderJobsTimesheetsIndexRoute: typeof ProviderProviderJobsTimesheetsIndexRoute
}

const ProviderProviderJobsRouteChildren: ProviderProviderJobsRouteChildren = {
  ProviderProviderJobsIndexRoute: ProviderProviderJobsIndexRoute,
  ProviderProviderJobsIdIndexRoute: ProviderProviderJobsIdIndexRoute,
  ProviderProviderJobsActiveIndexRoute: ProviderProviderJobsActiveIndexRoute,
  ProviderProviderJobsInterestsIndexRoute:
    ProviderProviderJobsInterestsIndexRoute,
  ProviderProviderJobsOffersIndexRoute: ProviderProviderJobsOffersIndexRoute,
  ProviderProviderJobsPreferencesIndexRoute:
    ProviderProviderJobsPreferencesIndexRoute,
  ProviderProviderJobsRecommendedIndexRoute:
    ProviderProviderJobsRecommendedIndexRoute,
  ProviderProviderJobsSearchIndexRoute: ProviderProviderJobsSearchIndexRoute,
  ProviderProviderJobsTimesheetsIndexRoute:
    ProviderProviderJobsTimesheetsIndexRoute,
}

const ProviderProviderJobsRouteWithChildren =
  ProviderProviderJobsRoute._addFileChildren(ProviderProviderJobsRouteChildren)

interface ProviderRouteChildren {
  ProviderProviderJobsRoute: typeof ProviderProviderJobsRouteWithChildren
  ProviderProviderOnboardingIndexRoute: typeof ProviderProviderOnboardingIndexRoute
  ProviderProviderIndexRoute: typeof ProviderProviderIndexRoute
  ProviderProviderAffiliationsIndexRoute: typeof ProviderProviderAffiliationsIndexRoute
  ProviderProviderBillingIndexRoute: typeof ProviderProviderBillingIndexRoute
  ProviderProviderChatIndexRoute: typeof ProviderProviderChatIndexRoute
  ProviderProviderCredentialsIndexRoute: typeof ProviderProviderCredentialsIndexRoute
  ProviderProviderDocumentsIndexRoute: typeof ProviderProviderDocumentsIndexRoute
  ProviderProviderHomeIndexRoute: typeof ProviderProviderHomeIndexRoute
  ProviderProviderProcedureLogIndexRoute: typeof ProviderProviderProcedureLogIndexRoute
  ProviderProviderProfileIndexRoute: typeof ProviderProviderProfileIndexRoute
  ProviderProviderReferralsIndexRoute: typeof ProviderProviderReferralsIndexRoute
  ProviderProviderSettingsIndexRoute: typeof ProviderProviderSettingsIndexRoute
  ProviderProviderShiftsIndexRoute: typeof ProviderProviderShiftsIndexRoute
  ProviderProviderWorkHistoryIndexRoute: typeof ProviderProviderWorkHistoryIndexRoute
  ProviderProviderShiftsPreferencesIndexRoute: typeof ProviderProviderShiftsPreferencesIndexRoute
  ProviderProviderShiftsSearchIndexRoute: typeof ProviderProviderShiftsSearchIndexRoute
}

const ProviderRouteChildren: ProviderRouteChildren = {
  ProviderProviderJobsRoute: ProviderProviderJobsRouteWithChildren,
  ProviderProviderOnboardingIndexRoute: ProviderProviderOnboardingIndexRoute,
  ProviderProviderIndexRoute: ProviderProviderIndexRoute,
  ProviderProviderAffiliationsIndexRoute:
    ProviderProviderAffiliationsIndexRoute,
  ProviderProviderBillingIndexRoute: ProviderProviderBillingIndexRoute,
  ProviderProviderChatIndexRoute: ProviderProviderChatIndexRoute,
  ProviderProviderCredentialsIndexRoute: ProviderProviderCredentialsIndexRoute,
  ProviderProviderDocumentsIndexRoute: ProviderProviderDocumentsIndexRoute,
  ProviderProviderHomeIndexRoute: ProviderProviderHomeIndexRoute,
  ProviderProviderProcedureLogIndexRoute:
    ProviderProviderProcedureLogIndexRoute,
  ProviderProviderProfileIndexRoute: ProviderProviderProfileIndexRoute,
  ProviderProviderReferralsIndexRoute: ProviderProviderReferralsIndexRoute,
  ProviderProviderSettingsIndexRoute: ProviderProviderSettingsIndexRoute,
  ProviderProviderShiftsIndexRoute: ProviderProviderShiftsIndexRoute,
  ProviderProviderWorkHistoryIndexRoute: ProviderProviderWorkHistoryIndexRoute,
  ProviderProviderShiftsPreferencesIndexRoute:
    ProviderProviderShiftsPreferencesIndexRoute,
  ProviderProviderShiftsSearchIndexRoute:
    ProviderProviderShiftsSearchIndexRoute,
}

const ProviderRouteWithChildren = ProviderRoute._addFileChildren(
  ProviderRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  OrgRoute: OrgRouteWithChildren,
  ProviderRoute: ProviderRouteWithChildren,
  ProviderInviteRoute: ProviderInviteRoute,
  SchedulerDemoRoute: SchedulerDemoRoute,
  AuthOrgNoOrganizationIndexRoute: AuthOrgNoOrganizationIndexRoute,
  AuthOrgSigninIndexRoute: AuthOrgSigninIndexRoute,
  AuthProviderSigninIndexRoute: AuthProviderSigninIndexRoute,
  AuthMfaIndexRoute: AuthMfaIndexRoute,
  JobsIdIndexRoute: JobsIdIndexRoute,
  AuthSigninLinkIndexRoute: AuthSigninLinkIndexRoute,
  AuthSigninOauthIndexRoute: AuthSigninOauthIndexRoute,
  AuthSigninRedirectIndexRoute: AuthSigninRedirectIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
